<style>
/* 仅编辑态全屏工作区覆盖通用弹框的居中和限宽，查看态保持原样。 */
.sjbz-req-dialog.el-dialog.is-fullscreen {
  position: fixed;
  inset: 0;
  width: 100vw !important;
  height: 100vh !important;
  max-width: none !important;
  max-height: none !important;
  margin: 0 !important;
  transform: none !important;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.sjbz-req-dialog > .el-dialog__header { flex-shrink: 0; padding: 18px 24px; border-bottom: 1px solid #ebeef5; }
.sjbz-req-dialog > .el-dialog__body { display: flex; flex: 1; min-height: 0; padding: 16px !important; overflow: hidden !important; background: #f5f7fa; }
.sjbz-req-dialog > .el-dialog__footer { flex-shrink: 0; padding: 12px 24px; border-top: 1px solid #ebeef5; }
.sjbz-req-editor { display: flex; flex: 1; min-width: 0; min-height: 0; flex-direction: column; gap: 14px; }
.sjbz-personnel-panel { flex-shrink: 0; border: 1px solid #e4e7ed; border-radius: 6px; background: #fff; padding: 0 16px; }
.sjbz-personnel-heading { display: flex; align-items: center; justify-content: space-between; gap: 16px; }
.sjbz-personnel-heading .sjbz-req-subtitle { padding: 0; }
.sjbz-personnel-fields { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 16px; max-height: 25vh; overflow: auto; text-align: left; }
.sjbz-personnel-fields .el-form-item { margin-bottom: 14px; }
.sjbz-req-editor .el-form-item__label { line-height: 1.6; padding-bottom: 8px; }
.sjbz-personnel-fields .el-form-item__label { padding-bottom: 4px; }
.sjbz-req-editor .el-select, .sjbz-req-editor .el-cascader { width: 100%; }
.sjbz-preview-label-row { margin-bottom: 8px; }
.sjbz-preview-label-row .sjbz-label-del { margin-top: 4px; }
.sjbz-preview-footer-tip { float: left; color: #909399; font-size: 12px; line-height: 32px; }
@media (max-width: 1100px) {
  .sjbz-personnel-fields { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}
@media (max-height: 700px) {
  .sjbz-personnel-fields { max-height: 64px; }
}
.contract-tips {
  display: flex;
  align-items: center;
  justify-content: center;
}

.el-collapse-item__header {
  padding-left: 15px;
}

.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}

.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}

.v-modal {
  z-index: 100 !important;
}

.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}

.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}

.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}

.management-list {
  display: flex;
  align-items: center;
  /* margin-bottom: 15px; */
}

.select-department {
  color: green;
  text-decoration: underline;
  cursor: pointer;
}

.management-name {
  flex-shrink: 0;
}

.designee {
  padding: 3px 10px 6px 10px;
  display: inline-block;
  border: 1px solid grey;
  box-sizing: border-box;
  line-height: 20px;
  margin-right: 10px;
}

.input-item {
  display: flex;
  align-items: center;
  margin-left: 20px;
  margin-bottom: 25px;
}

.input-item .input-title {
  margin-right: 14px;
}

.add {
  text-align: left;
  color: #4fa1a4;
  text-decoration: underline;
  cursor: pointer;
}

.del {
  color: #4fa1a4;
  text-decoration: underline;
  cursor: pointer;
  margin-left: 10px;
}

.product-item {
  display: flex;
  margin-top: 10px;
}

.product {
  display: flex;
  align-items: center;
}

.product-img {
  width: 60px;
  height: 60px;
  margin-right: 15px;
}

.product-text {
  width: 130px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.depart-choose {
  width: 300px;
  height: 30px;
  border: 1px solid #dcdfe6;
  box-sizing: content-box;
  border-radius: 4px;
  cursor: pointer;
  text-align: left;
  display: flex;
  align-items: center;
  font-size: 14px;
}

.place-choose {
  padding-left: 10px;
  color: #dcdfe6;
}

.place-show {
  padding-left: 10px;
}

.task-precent {
  width: 70px;
  height: 20px;
  margin: 0 10px;
}

#template-config .calc-type .el-form-item__content {
  margin-left: 15px !important;
}

.template-config .has-gutter .el-checkbox {
  display: none;
}

.btn-groups-operate {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.btn-groups-operate .btn {
  margin-left: 10px;
}
</style>
<template>
  <div class="template-config">
    <!-- 配置 -->
    <div class="back-color-fff tabel-wrap">
      <div class="btn-groups-operate">
        <el-button size="mini" type="info" v-if="!disabled" @click="chooseTemplate" class="btn">从模版选择</el-button>
        <el-button size="mini" type="info" v-if="disabled && autoForecastOpen == '1'" class="btn"
          @click="seeForecast">查看预测</el-button>
        <el-button size="mini" type="info" v-if="!disabled" @click="setRule" class="btn">设置执行规则</el-button>
        <el-button size="mini" type="info" v-else @click="setRule" class="btn">查看执行规则</el-button>
        <el-button size="mini" type="danger" v-if="!disabled" @click="delTemplate" class="btn">批量删除</el-button>
      </div>
      <el-table @selection-change="handleSelectionChange2" :data="tableData" :height="tableHeight" stripe border
        header-cell-class-name="table_header" style="width: 100%">
        <el-table-column type="selection" v-if="!disabled" fixed="left"></el-table-column>
        <el-table-column label="序号" width="60" header-align="center" align="center" fixed="left">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <!-- 任务名称 -->
        <el-table-column prop="taskContentName" label="项目任务名称" show-overflow-tooltip width="200" header-align="center"
          align="center" fixed="left">
          <template slot-scope="scope">
            <span v-if="scope.row.activeTemlate=='2'">
              <el-input size="mini" v-if="isPartDisabled" v-model="scope.row.tenantTaskContentName" />
              <el-input size="mini" v-else-if="!disabled" v-model="scope.row.tenantTaskContentName" />
              <span v-else>
                <div v-if="scope.row.contractTaskType != 0">
                  <el-tooltip class="contract-tips" effect="dark"
                    :content="scope.row.contractTaskType==2?'该任务在当前企业合同中未签约，请尽快签署补充协议变更合同任务':'该任务未签署合同，请尽快签署合同'"
                    placement="right-start">
                    <span>{{ scope.row.tenantTaskContentName }}<img src="../assets/icon/import_warning.png" alt=""
                        style="width:15px;" /></span>
                  </el-tooltip>
                </div>
                <div v-else>{{ scope.row.tenantTaskContentName }}</div>
              </span>
            </span>
            <span v-else>
              <el-input size="mini" v-if="isPartDisabled" v-model="scope.row.taskContentName" />
              <el-input size="mini" v-else-if="!disabled" v-model="scope.row.taskContentName" />
              <span v-else>
                <div v-if="scope.row.contractTaskType != 0">
                  <el-tooltip class="contract-tips" effect="dark"
                    :content="scope.row.contractTaskType==2?'该任务在当前企业合同中未签约，请尽快签署补充协议变更合同任务':'该任务未签署合同，请尽快签署合同'"
                    placement="right-start">
                    <span>{{ scope.row.taskContentName }}<img src="../assets/icon/import_warning.png" alt=""
                        style="width:15px;" /></span>
                  </el-tooltip>
                </div>
                <div v-else>{{ scope.row.taskContentName }}</div>
              </span>
            </span>

          </template>

        </el-table-column>

        <!-- 系统功能 -->
        <el-table-column prop="menuName" label="系统功能" header-align="center" width="200" align="center">
          <!-- 非问卷调查 -->
          <template slot-scope="scope">
            <div v-if="scope.row.menuUrl !== '/subFillingApp/questionnaireFilling'">
              {{ scope.row.menuName || '-' }}{{ scope.row.menuRemark ? '（' + scope.row.menuRemark + '）' : '' }}
            </div>
            <div v-else>
              <span v-if="!getSurveyName(scope.row.surveyObj)" class="txt-color"
                @click="handleChooseSurvey(scope.$index)">请选择</span>
              <span style="cursor: pointer" @click="handleChooseSurvey(scope.$index)">{{
                getSurveyName(scope.row.surveyObj) }}</span>
            </div>
          </template>
          <!-- 问卷调查 -->
        </el-table-column>

        <!-- 药企报价 -->
        <el-table-column prop="tenantTaskPrice" label="药企报价" :render-header="renderHeader"
          :width="disabled ? '140' : taskPriceModel == 2 ? '300' : '200'" header-align="center" align="center">
          <template slot-scope="scope">
            <!-- 区间价 -->
            <div v-if="taskPriceModel == 2">
              <div style="display: flex" v-if="!disabled">
                <el-input type="input" size="mini" style="width: 128px; margin-right: 5px;" :maxlength="30"
                  placeholder="请输入" v-model.trim="scope.row.tenantMinPrice"
                  oninput="if(!value)value='';if(value)value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')">

                </el-input>
                至
                <el-input type="input" size="mini" style="width: 128px; margin:0 5px;" :maxlength="30" placeholder="请输入"
                  v-model.trim="scope.row.tenantMaxPrice"
                  oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')">
                </el-input>
                <el-select size="mini" v-model="scope.row.tenantTaskPriceUnitGuid" placeholder="单位"
                  @change="handleSelecTaskPriceUnit(scope.row.tenantTaskPriceUnitGuid, 0, scope.$index)">
                  <el-option v-for="(item, index) in taskPriceUnitList" :key="index" :label="item.paramValue"
                    :value="item.guid"></el-option>
                </el-select>
              </div>
              <div v-else>{{ scope.row.tenantMinPrice }}～{{ scope.row.tenantMaxPrice }} {{ scope.row.tenantTaskPriceUnit
                }}
              </div>
            </div>
            <!-- 固定价 -->
            <div v-else>
              <div style="display: flex" v-if="!disabled">
                <el-input type="input" size="mini" style="width: 128px; margin-right: 5px;" :maxlength="30"
                  placeholder="请输入价格" v-model.trim="scope.row.tenantTaskPrice"
                  oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')">
                </el-input>
                <el-select size="mini" v-model="scope.row.tenantTaskPriceUnitGuid" placeholder="单位"
                  @change="handleSelecTaskPriceUnit(scope.row.tenantTaskPriceUnitGuid, 0, scope.$index)">
                  <el-option v-for="(item, index) in taskPriceUnitList" :key="index" :label="item.paramValue"
                    :value="item.guid"></el-option>
                </el-select>
              </div>
              <div v-else>{{ scope.row.tenantTaskPrice || '-' }} {{ scope.row.tenantTaskPriceUnit }}</div>
            </div>
          </template>
        </el-table-column>

        <!-- 业务员报价 -->
        <el-table-column prop="taskPrice" :label="taskPriceModel == 2?'业务员基础报价':'业务员报价'" :render-header="renderHeaderII" header-align="center"
          :width="disabled ? '140' : taskPriceModel == 2 ? '300' : '200'" align="center">
          <template slot-scope="scope">
            <!-- 区间价 -->
            <div v-if="taskPriceModel == 2">
              <div style="display: flex" v-if="!disabled&&!scope.row.staffMinPrice">
                <el-input type="input" size="mini" style="width: 128px; margin-right: 5px;" :maxlength="30"
                  placeholder="请输入价格" v-model.trim="scope.row.taskPrice"
                  oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')">
                </el-input>
                <div style="word-break: keep-all;margin-left:10px">{{ scope.row.taskPriceUnit }}</div>
              </div>
              <div v-else-if="disabled&&scope.row.staffMinPrice&&scope.row.staffMaxPrice">{{ scope.row.staffMinPrice
                }}～{{ scope.row.staffMaxPrice }} {{ scope.row.taskPriceUnit}}</div>
              <div v-else>{{ scope.row.taskPrice }} {{ scope.row.taskPriceUnit}}</div>
            </div>
            <!-- 固定价 -->
            <div v-else>
              <div style="display: flex" v-if="!disabled">
                <el-input type="input" size="mini" style="width: 128px; margin-right: 5px;" :maxlength="30"
                  placeholder="请输入价格" v-model.trim="scope.row.taskPrice"
                  oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')">
                </el-input>
                <div style="word-break: keep-all;margin-left:10px">{{ scope.row.taskPriceUnit }}</div>
              </div>
              <div v-else>{{ scope.row.taskPrice || '-' }} {{ scope.row.taskPriceUnit }}</div>
            </div>
            <!-- <div style="display: flex;align-items:center;"
              v-if="isPartDisabled && !taskPriceDisabled && $route.query.state == '待派发'">
              <el-input size="mini" style="width: 128px; margin-right: 5px;" :maxlength="30" placeholder="请输入价格"
                v-model.trim="scope.row.taskPrice"
                oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')">
              </el-input>
              <div style="margin-left:10px">{{ scope.row.taskPriceUnit }}</div>
            </div> -->
            <!-- <div style="display: flex" v-else-if="!disabled">
              <el-input size="mini" type="input" style="width: 128px; margin-right: 5px;" :maxlength="30"
                placeholder="请输入价格" v-model.trim="scope.row.taskPrice"
                oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')">
              </el-input>
              <div style="word-break: keep-all;margin-left:10px">{{ scope.row.taskPriceUnit }}</div>
            </div>
            <span v-else style="word-break: keep-all;">{{ scope.row.taskPrice }} {{ scope.row.taskPriceUnit }}</span> -->
          </template>
        </el-table-column>

        <!-- 浮动比例 -->
        <el-table-column v-if="taskPriceModel==2" prop="discountRatio" label="浮动比例" show-overflow-tooltip width="80"
          header-align="center" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.floatDiscountRatio != null ? scope.row.floatDiscountRatio : '-' }}</span>
          </template>
        </el-table-column>

        <!-- 折扣比列 -->
        <el-table-column v-if="taskPriceModel==2" prop="discountRatio" label="折扣比例" header-align="center"
          :width="disabled ? '80': '140'" align="center">
          <template slot-scope="scope">
            <el-input :class="scope.row.checkDiscountMsg?'active-ratio':''" v-if="!disabled" size="mini"
              @blur="checkDiscountRatio(scope.row,scope.$index)"
              oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
              placeholder="请输入" v-model.trim="scope.row.discountRatio"></el-input>
            <span v-else>{{ scope.row.discountRatio?scope.row.discountRatio.toFixed(2):'-'}}</span>
            <div v-if="scope.row.checkDiscountMsg" class="ratio-msg">{{scope.row.checkDiscountMsg}}</div>
          </template>
        </el-table-column>

        <!-- 计算方式 -->
        <el-table-column prop="calcType" label="计算方式" show-overflow-tooltip width="150" header-align="center"
          align="center">
          <template slot-scope="scope">
            <el-select size="mini" v-if="!disabled && autoForecastOpen == '0'&&scope.row.settleRule!=2"
              @change="calcTypeChange(scope.$index)" v-model="scope.row.calcType" placeholder="计算方式">
              <el-option v-for="(item, index) in calcTypeOptions(scope.row)" :key="index" :label="item" :value="item"></el-option>
            </el-select>
            <span v-else>{{ scope.row.calcType }}</span>
          </template>
        </el-table-column>

        <!-- 任务量设置 -->
        <el-table-column prop="taskTotal" label="任务量设置" :render-header=renderHeaderIII header-align="center"
          :width="disabled ? '180': '280'" align="center">
          <template slot-scope="scope">
            <div style="display: flex;justify-content:center;"
              v-if="!disabled && scope.row.calcType != '按学术活动计划' && (autoForecastOpen == '0' || isSjbzRow(scope.row))">
              <!-- SJBZ 行级豁免：02 编辑页未传 autoForecastOpen（普通行任务量保持只读零改动），
               SJBZ 行任务量输入仍需可用（固定量人均=人均、系统计算=总量，placeholder 随 calcType） -->
              <el-input size="mini" type="input" style="width: 80px; float: left"
                @input="scope.row.taskTotal=scope.row.taskTotal.replace(/[^\d]/g,'')"
                :placeholder="isSjbzRow(scope.row) && scope.row.calcType == '系统计算' ? '按数据集' : scope.row.calcType == '系统计算' ? '任务总量' : scope.row.calcType == '固定量人均' ? '人均任务量' : ''"
                v-model="scope.row.taskTotal" :disabled="scope.row.calcType == '按学术活动计划' || (isSjbzRow(scope.row) && scope.row.calcType == '系统计算')"
                v-if="scope.row.calcType == '系统计算' || scope.row.calcType == '固定量人均'">
              </el-input>

              <el-select size="mini"
                :style="scope.row.calcType == '不限量' ? 'width:220px' : 'width: 100px; float: left; margin-left: 20px'"
                v-model="scope.row.taskTotalUnitGuid"
                @change="handleSelecTaskTotalUnit(scope.row.taskTotalUnitGuid, scope.$index)" placeholder="单位">
                <el-option v-for="(item, index) in taskTotalUnitList" :key="index"
                  :label="item.paramValue + '(' + item.paramValue1 + ')'" :value="item.guid"></el-option>
              </el-select>
            </div>
            <div v-else>
              <div v-if="scope.row.calcType == '不限量'">不限量/{{scope.row.taskTotalUnit }}<span style="color:#FF991C;">({{
                  scope.row.countRule }})</span></div>
              <div v-else-if="scope.row.calcType == '固定量人均'">{{ isSjbzRow(scope.row) ? (scope.row.taskAvg > 0 ? scope.row.taskAvg : (scope.row.taskTotal || '')) : scope.row.taskAvg }} {{scope.row.taskTotalUnit }}<span
                  style="color:#FF991C;">({{
                  scope.row.countRule }})</span></div>
              <div v-else>{{ scope.row.taskTotal }} {{ scope.row.taskTotalUnit }}<span style="color:#FF991C;">({{
                  scope.row.countRule }})</span></div>
            </div>
          </template>
        </el-table-column>

        <!-- 超量上限拦截 -->
        <el-table-column label="超量上限拦截" header-align="center" :width="disabled&&!isPartDisabled ? '120': '160'"
          align="center">
          <span slot-scope="scope">
            <div v-if="isPartDisabled" style="display: flex;align-items:center;">
              <el-switch size="mini" v-model="scope.row.isOpenMaxTask" active-color="#4fa1a4" inactive-color="#DCDFE6"
                active-value="Y" inactive-value="N" :disabled="scope.row.calcType == '不限量'">
              </el-switch>
              <el-input size="mini" type="input" style="width: 80px;margin:0 10px" placeholder="0-100"
                v-model="scope.row.maxTaskValue"
                oninput="if(!/^[0-9]+$/.test(value)) value=value.replace(/\D/g,'');if(value>100)value=100;if(value<0)value=null"
                :disabled="scope.row.calcType == '不限量'">

              </el-input>
              <span>%</span>
            </div>
            <div v-else-if="!disabled" style="display: flex;align-items:center;">
              <el-switch size="mini" v-model="scope.row.isOpenMaxTask" active-color="#4fa1a4" inactive-color="#DCDFE6"
                active-value="Y" inactive-value="N" :disabled="scope.row.calcType == '不限量'">
              </el-switch>
              <el-input size="mini" type="input" style="width: 80px;margin:0 10px" placeholder="0-100"
                v-model="scope.row.maxTaskValue"
                oninput="if(!/^[0-9]+$/.test(value)) value=value.replace(/\D/g,'');if(value>100)value=100;if(value<0)value=null"
                :disabled="scope.row.calcType == '不限量'">
              </el-input>
              <span>%</span>
            </div>
            <div v-else>
              {{ scope.row.isOpenMaxTask == 'N' ? '否' : '是，' + scope.row.maxTaskValue + '%' }}
            </div>
          </span>
        </el-table-column>

        <!-- N7 行级化：标注行三列（02sheet 示意图口径——位置在超量上限拦截后；
             选择标注数据=数据集下拉必填（仅待标注态）/ 标注人员要求=去设置弹框非必填 / 质检比例=0<x≤100 默认 100；
             仅含 SJBZ 行的表格才渲染，普通行单元格显示 '-'，普通任务表格零影响） -->
        <template v-if="hasSjbzRows">
          <el-table-column label="选择标注数据" header-align="center" align="center" width="200">
            <template slot-scope="scope">
              <template v-if="isSjbzRow(scope.row)">
                <el-select v-if="sjbzEditable" v-model="sjbzConf(scope.row).datasetGuid" size="mini" filterable clearable
                  placeholder="请选择数据集" style="width: 100%" @change="onSjbzDatasetChange(scope.row)">
                  <el-option v-for="item in sjbzDatasetOptions" :key="item.guid" :label="sjbzDatasetLabel(item)"
                    :value="item.guid"></el-option>
                </el-select>
                <span v-else>{{ sjbzConf(scope.row).datasetName || '-' }}</span>
              </template>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="标注人员要求" header-align="center" align="center" width="110">
            <template slot-scope="scope">
              <template v-if="isSjbzRow(scope.row)">
                <span v-if="sjbzEditable" class="txt-color" @click="openSjbzReq(scope.row)">{{ sjbzReqSet(scope.row) ? '已设置' : '去设置' }}</span>
                <a v-else-if="sjbzReqSet(scope.row)" class="txt-color" @click="openSjbzReq(scope.row, true)">查看</a>
                <span v-else>-</span>
              </template>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="质检比例" header-align="center" align="center" width="110">
            <template slot-scope="scope">
              <template v-if="isSjbzRow(scope.row)">
                <div v-if="sjbzEditable" style="display: flex; align-items: center; justify-content: center;">
                  <el-input size="mini" type="input" style="width: 70px" placeholder="0-100"
                    v-model="sjbzConf(scope.row).qcRatio" @change="onSjbzRatioChange(scope.row)"
                    oninput="if(!/^[0-9]+$/.test(value)) value=value.replace(/\D/g,'');if(value>100)value=100">
                  </el-input>
                  <span style="margin-left: 2px">%</span>
                </div>
                <span v-else>{{ sjbzConf(scope.row).qcRatio != null ? sjbzConf(scope.row).qcRatio + '%' : '-' }}</span>
              </template>
              <span v-else>-</span>
            </template>
          </el-table-column>
        </template>

        <!-- 品种信息 //!暂时隐藏 -->
        <el-table-column prop="taskType" label="限定品种" show-overflow-tooltip width="200" header-align="center"
          align="center">
          <template slot-scope="scope">
            <div v-if="isPartDisabled||disabled">
              <span v-if="scope.row.multipleSelection.length == 0">-</span>
              <span v-else class="txt-color" @click="handleChooseGoods(scope.$index)">共{{
                scope.row.multipleSelection.length
                }}个品</span>
            </div>
            <div v-else>
              <template v-if="limitTaskDicts.indexOf(scope.row.taskContentType) > -1">
                <span v-if="scope.row.multipleSelection.length == 0" class="txt-color"
                  @click="handleChooseGoods(scope.$index)">请选择</span>
                <span v-else class="txt-color" @click="handleChooseGoods(scope.$index)">共{{
                  scope.row.multipleSelection.length
                  }}个品</span>
              </template>
              <template v-else>-</template>
            </div>

          </template>
        </el-table-column>

        <!-- 选择标签 -->
        <el-table-column prop="surveyLabelList" label="选择标签" show-overflow-tooltip width="250" header-align="center"
          align="center">
          <template slot-scope="scope">
            <el-cascader
              style="width: 100%;"
              v-if="isPartDisabled || !disabled"
              :value="scope.row.surveyLabelList"
              :options="surveyLabelOptions"
              collapse-tags
              filterable
              :show-all-levels="false"
              :props="{
                value: 'value',
                label: 'text',
                children: 'childDictList',
                multiple: true,
                checkStrictly: true,
                emitPath: false,
              }"
              @change="(val) => updateLabels(val, scope.row)"
              clearable
              popper-class="cascader-popper"
            >
            </el-cascader>
            <div v-else>
              {{ getSurveyLabelNames(scope.row.surveyLabelList) }}
            </div>
          </template>
        </el-table-column>


        <!-- 打卡要求 -->
        <el-table-column prop="isAskClock" label="打卡要求" show-overflow-tooltip width="85" header-align="center"
          align="center">
          <template slot-scope="scope">
            <el-select size="mini" v-if="!disabled" v-model="scope.row.isAskClock" placeholder="是否要求">
              <el-option v-for="(item, index) in ['是', '否']" :key="index" :label="item" :value="item"></el-option>
            </el-select>
            <div v-else>{{ scope.row.isAskClock || '不要求' }}</div>
          </template>
        </el-table-column>

        <!-- 拍照要求 -->
        <el-table-column label="拍照要求" header-align="center" show-overflow-tooltip :width="disabled ? '120': '170'"
          align="center">
          <template slot-scope="scope">
            <div style="display: flex;" v-if="!disabled">
              <el-select size="mini" style="width: 110px; margin-right: 5px;" v-model="scope.row.isAskPhoto"
                placeholder="是否要求">
                <el-option v-for="(item, index) in ['是', '否']" :key="index" :label="item" :value="item"></el-option>
              </el-select>
              <el-input size="mini" type="input" :maxlength="30" placeholder="至少几张" v-model="scope.row.minAskPhoto"
                oninput="value=value.replace(/[^\.\d]/g,'')">
              </el-input>
            </div>
            <div v-else>
              <div>{{ scope.row.isAskPhoto == '是' ? `要求拍照，至少${scope.row.minAskPhoto}张` : '不要求' }}</div>
            </div>
          </template>
        </el-table-column>

        <!-- 上传资料 -->
        <el-table-column label="上传资料" header-align="center" :width="disabled ? '120': '170'" show-overflow-tooltip
          align="center">
          <template slot-scope="scope">
            <div style="display: flex" v-if="!disabled">
              <el-select size="mini" style="width: 110px; margin-right: 5px;" v-model="scope.row.isAskUpload"
                placeholder="是否要求">
                <el-option v-for="(item, index) in ['是', '否']" :key="index" :label="item" :value="item"></el-option>
              </el-select>
              <el-input size="mini" type="input" :maxlength="30" placeholder="至少几张" v-model="scope.row.minAskUpload"
                oninput="value=value.replace(/[^\.\d]/g,'')">
              </el-input>
            </div>
            <div v-else>
              <div>{{ scope.row.isAskUpload == '是' ? `要求上传资料，至少${scope.row.minAskUpload}份` : '不要求' }}</div>
            </div>
          </template>
        </el-table-column>

        <!-- 平台任务名称 -->
        <el-table-column prop="parentTemplateDetailName" label="平台任务名称" show-overflow-tooltip width="150"
          header-align="center" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.parentTemplateDetailName || '-' }}</span>
          </template>
        </el-table-column>
        <!-- 任务大类 -->
        <el-table-column prop="taskType" label="任务大类" show-overflow-tooltip width="150" header-align="center"
          align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.taskType }}</span>
          </template>
        </el-table-column>

        <el-table-column width="260px" label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <a class="txt-color" v-if="!disabled && !isPartDisabled" @click="editVersion(scope.$index)">更多｜</a>
            <a class="txt-color" v-if="isPartDisabled" @click="editVersion(scope.$index)">更多</a>
            <a class="txt-color" v-if="disabled && !isPartDisabled" @click="editVersion(scope.$index)">查看</a>
            <a class="txt-color" v-if="!disabled && scope.$index != 0" @click="moveUp(scope.$index)">上移｜</a>
            <a class="txt-color" v-if="!disabled && scope.$index != tableData.length - 1"
              @click="moveDown(scope.$index)">下移｜</a>
            <a class="txt-color" v-if="!disabled" @click="delVersion(scope.$index)">删除</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 弹窗 -->
    <div v-show="!iconVisible" id="template-config">
      <el-dialog :title="textTitle" :visible.sync="dialogVisible" width="740px" height="100vh">
        <template v-if="dialogVisible">
          <el-form label-width="140px" :label-position="right" class="demo-ruleForm">
            <div class="calc-type">
              <el-form-item>
                <span slot="label" style="color: red">*</span>
                <span slot="label">任务结算规则</span>
                <div style="display:flex;flex-direction:column;text-align: left;">
                  <el-radio style="margin-bottom:6px;" disabled v-model="tableData[currentIndex].settleRule"
                    label="1">按单价结算，完成量*单价结算</el-radio>
                  <el-radio disabled v-model="tableData[currentIndex].settleRule" label="2">按比例结算，当任务量大于0时，按任务量的
                    <el-input :disabled="tableData[currentIndex].settleRule == 1 || isPartDisabled" class="task-precent"
                      v-model="tableData[currentIndex].settlePercent" oninput="value=value.replace(/[^\d]/g,'')" />%结算
                    <el-tooltip class="item" effect="dark"
                      content="例如：某个人发放 7 万元费用，比例配置为40%，只要有做此任务，那么结算金额最高为 2.8万元（7万 * 40%）" placement="right-start"><i
                        class="el-icon-question"></i></el-tooltip>
                  </el-radio>
                </div>
              </el-form-item>
            </div>
            <div class="calc-type">
              <el-form-item>
                <span slot="label" style="color: red">*</span>
                <span slot="label">限定客户区域 </span>
                <div style="display: flex; flex-direction: column; align-items: flex-start;">
                  <el-radio style="margin-bottom:12px;" :disabled="disabled || isPartDisabled" label="不限区域"
                    v-model="tableData[currentIndex].clientAreaRadio">不限客户区域</el-radio>
                  <el-radio
                    :style="tableData[currentIndex].clientAreaRadio == '指定区域' ? 'margin-bottom:0;' : 'margin-bottom:12px;'"
                    :disabled="disabled || isPartDisabled" label="本区域"
                    v-model="tableData[currentIndex].clientAreaRadio">本销售区域客户</el-radio>
                  <el-radio :disabled="disabled || isPartDisabled" label="指定区域"
                    v-model="tableData[currentIndex].clientAreaRadio">指定客户区域
                    <div v-if="tableData[currentIndex].clientAreaRadio == '指定区域'"
                      style="margin-left: 14px;display:inline-block">
                      <el-cascader ref="cascaderAddr" placeholder="请选择" collapse-tags :options="provinceAndCityData"
                        v-model="tableData[currentIndex].clientArea" :props="{ multiple: true, checkStrictly: false }"
                        :disabled="disabled || isPartDisabled" filterable @change="handleProvinceAndCity">
                      </el-cascader>
                    </div>
                  </el-radio>


                </div>
              </el-form-item>
            </div>
            <el-form-item>
              <span slot="label" style="color: red">*</span>
              <span slot="label">工作内容描述<el-tooltip class="item" effect="dark" content="手机端展示" placement="right-start"><i
                    class="el-icon-question"></i></el-tooltip>
              </span>
              <div class="fl" style="width: 400px">
                <!-- <div class="fl">
                  选择自定义标签:
                  <span style="cursor: pointer; text-decoration: underline; margin: 0 10px"
                    @click="chooseAreaGoods(0)">客户区域</span>
                  <span style="cursor: pointer; text-decoration: underline" @click="chooseAreaGoods(1)">定义品种</span>
                  <span style="cursor: pointer; text-decoration: underline; margin: 0 10px"
                    @click="chooseAreaGoods(2)">总任务量</span>
                  <span style="cursor: pointer; text-decoration: underline" @click="chooseAreaGoods(3)">任务量单位</span>
                </div> -->
                <el-input class="fl" style="width: 400px" type="textarea" :rows="5" :maxlength="200" placeholder="请输入"
                  v-model="tableData[currentIndex].staffTaskNote" :disabled="!sjbzNoteEditable">
                </el-input>
              </div>
            </el-form-item>
            <!-- <el-form-item>
              <span slot="label">药企工作要求
                <el-tooltip class="item" effect="dark" content="药企对运营方的工作要求" placement="right-start"><i
                    class="el-icon-question"></i></el-tooltip>
              </span>
              <div class="fl" style="width: 400px">
                <el-input class="fl" style="width: 400px" type="textarea" :rows="5" :maxlength="200" placeholder="请输入"
                  v-model="tableData[currentIndex].tenantWorkNote" disabled>
                </el-input>
              </div>
            </el-form-item> -->
            <el-form-item>
              <span slot="label" style="color: red">*</span>
              <span slot="label">工作内容明细
                <el-tooltip class="item" effect="dark" content="手机端、PC端详细展示" placement="right-start"><i
                    class="el-icon-question"></i></el-tooltip>
              </span>
              <div class="fl" style="width: 400px">
                <el-input class="fl" style="width: 400px" type="textarea" :rows="5" :maxlength="200" placeholder="请输入"
                  v-model="tableData[currentIndex].tenantTaskNote" :disabled="!sjbzNoteEditable" />
              </div>
            </el-form-item>

            <el-form-item>
              <span slot="label" style="color: red">*</span>
              <span slot="label">任务管理要求
                <el-tooltip class="item" effect="dark" content="手机端展示给业务员看的工作要求" placement="right-start"><i
                    class="el-icon-question"></i></el-tooltip>
              </span>
              <div class="fl" style="width: 400px">
                <el-input class="fl" style="width: 400px" type="textarea" :rows="5" :maxlength="200" placeholder="请输入"
                  v-model="tableData[currentIndex].staffWorkNote" :disabled="!sjbzNoteEditable" />

              </div>
            </el-form-item>
            <el-form-item>
              <span slot="label">任务标签
              </span>
              <el-select collapse-tags style="width: 170px; float: left" v-model="tableData[currentIndex].taskLabel"
                placeholder="请选择标签" filterable class="fl" :multiple-limit="3" multiple>
                <el-option v-for="item in taskLabelListList" :key="item" :label="item" :value="item"></el-option>
              </el-select>
              <el-input type="input" style="width: 150px; float: left;margin: 0 10px;" :maxlength="6"
                placeholder="新增标签名称" v-model.trim="taskLabelVal" />
              <el-button size="mini" style="float: left; height: 35px;margin-top: 3px;"
                @click="addLable()">新增</el-button>
            </el-form-item>

            <!-- <el-form-item>
              <span slot="label" style="color: red">*</span>
              <span slot="label">任务图标 </span>
              <div class="img-close"
                v-if="tableData[currentIndex].fileList.length != 0 && tableData[currentIndex].fileList[0].url">
                <img class="file-img" :src="tableData[currentIndex].fileList && tableData[currentIndex].fileList[0].url"
                  alt="" srcset="" />
              </div>
            </el-form-item> -->

          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button size="medium" type="info" @click="moreSure" v-loading.fullscreen.lock="fullscreenLoading">确 定
            </el-button>
          </span>
        </template>
      </el-dialog>
    </div>
    <el-dialog title="任务图标选择" class="icon-dialog-wrap" :visible.sync="iconVisible" width="50%">
      <div class="icon-dialog">
        <div class="icon-left">
          <div class="item" :style="activeIcon == index ? 'background:#EDEDED;' : ''" @click="handleClickMenu(index)"
            v-for="(item, index) in iconList" :key="index">
            <el-tooltip :content="item.paramName" placement="top">
              <span>
                {{ item.paramName }}
              </span>
            </el-tooltip>
          </div>
        </div>

        <div class="icon-right">
          <div class="pic" v-for="(item, index) in iconList[activeIcon] &&
            iconList[activeIcon].paramValue &&
            JSON.parse(iconList[activeIcon].paramValue)" :key="index">
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button size="medium" type="info" @click="moreSureIcon">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="选择部门" :visible.sync="visible3" width="70%" center>
      <div>
        <div class="select-box">
          <div class="box-left fl">
            <el-input v-model="filterText" class="ipt-sty mt15" placeholder="请输入部门名称"></el-input>
            <p class="fontC-bbb">组织架构</p>
            <el-tree class="filter-tree" :data="areaData" :props="defaultProps" :filter-node-method="filterNode"
              @check="handleNodeClick1" :check-strictly="true" show-checkbox ref="tree" node-key="guid" v-if="visible3">
            </el-tree>
          </div>
          <div class="box-right fr">
            <p class="fontC-bbb fl">已选{{ departmentList.length }}个部门</p>
            <el-button size="medium" type="danger" @click="delDepartment()" class="fr" style="margin-top: 5px">批量删除
            </el-button>
            <el-table :data="departmentList" border height="280px" style="width: 100%"
              @selection-change="handleSelectionChange1">
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column header-align="center" align="center" show-overflow-tooltip prop="organisationName"
                label="名称">
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer t-right">
        <el-button plain size="medium" @click="visible3 = false">取消</el-button>
        <el-button size="medium" type="info" @click="departmentSure()">确定</el-button>
      </div>
    </el-dialog>
    <!-- <el-dialog title="选择产品" ref="multipleTable" :visible.sync="visible2" width="70%" center>
      <el-row :gutter="24" class="mb30">
        <el-col :span="13">
          <div class="search-area-div w80">产品名称：</div>
          <el-input v-model="pageII.goodsName" class="ipt-sty" placeholder="请输入"></el-input>
        </el-col>
        <el-col :span="3">
          <el-button size="medium" type="info" @click="searchData()">搜索</el-button>
        </el-col>
      </el-row>
      <el-table :data="productInformationList" style="width: 100%" row-key="guid" border
        @selection-change="handleSelectionChange" v-loading="loading" ref="dataTable" @row-click="btn">
        <el-table-column type="selection" :reserve-selection="true"> </el-table-column>
        <el-table-column prop="goodsName" label="产品" header-align="center" align="left" show-overflow-tooltip>
          <template slot-scope="scope"> {{ scope.row.goodsName }} </template>
        </el-table-column>
        <el-table-column prop="goodsSpec" label="规格" header-align="center" align="left" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="producer" label="生产企业" header-align="center" align="center" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="price" label="单位" header-align="center" align="center">
          <template slot-scope="scope"> {{ scope.row.unitStyle }} </template>
        </el-table-column>
        <el-table-column prop="price" label="单价" header-align="center" align="center">
          <template slot-scope="scope"> {{ scope.row.price | numDigit | numFmt }} </template>
        </el-table-column>
        <el-table-column prop="price" label="是否主品" header-align="center" align="center">
          <template slot-scope="scope"> {{ scope.row.isMain == 'Y' ? '是' : '否' }} </template>
        </el-table-column>
      </el-table>
      <el-pagination class="pt pb back-color-fff" background @size-change="handleSizeChange1"
        @current-change="handleCurrentChange1" :current-page="pageII.pageIndex" :page-size="pageII.pageSize"
        layout="total, prev, pager, next, jumper" :total="pageII.totalRows">
      </el-pagination>
      <div slot="footer" class="dialog-footer t-right">
        <p class="t-left fl" style="font-size: 14px">
          本次已选择{{ tableData[currentIndex] && tableData[currentIndex].multipleSelection.length }}个产品
        </p>
        <el-button plain size="medium" @click="visible2 = false">取消</el-button>
        <el-button size="medium" type="info" @click="submitForm()">确定</el-button>
      </div>
    </el-dialog> -->
    <div v-if="visible4">
      <!-- :title="sendTenantName + '问卷'" -->
      <el-dialog title="问卷模板选择" ref="multipleTable" :visible.sync="visible4" width="70%" center>
        <el-row :gutter="24" class="mb30">
          <el-col :span="13">
            <div class="search-area-div w80">问卷名称</div>
            <el-input v-model="surveyPage.surveyTitle" class="ipt-sty" placeholder="请输入"></el-input>
          </el-col>
          <el-col :span="3">
            <el-button size="medium" type="info" @click="searchSurvey()">搜索</el-button>
          </el-col>
        </el-row>
        <el-table :data="surveyList" row-key="guid" style="width: 100%" border ref="singleTable"
          @select="handleSelectSurvey" @row-click="handleClickSurvey">
          <!-- <el-table-column  header-align="center" align="center"  style="width:60px;" > 
  				     <template scope="scope">
  				      <el-radio  v-model="radio" @change.native="getCurrentRow(scope.row)" style="color: #fff;padding-left: 10px; margin-right: -25px;">{{" "}}</el-radio>
  				    </template>
          </el-table-column> -->

          <el-table-column type="selection" :reserve-selection="true"> </el-table-column>
          <el-table-column label="序号" width="60" header-align="center" align="center">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>

          <el-table-column prop="surveyTitle" label="问卷名称" header-align="center" align="left" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="isShowPlatformTemplate" label="问卷来源" header-align="center" align="left"
            show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.isPlatformTemplate=='Y'?'平台':'药企' }}
            </template>
          </el-table-column>
          <el-table-column prop="surveyDesc" label="问卷描述" header-align="center" align="left" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="subjectNum" label="题目数量" header-align="center" align="center" show-overflow-tooltip>
          </el-table-column>
        </el-table>
        <el-pagination class="pt pb back-color-fff" background @size-change="handleSizeChangeSurvey"
          @current-change="handleCurrentChangeSurvey" :current-page="surveyPage.pageIndex"
          :page-size="surveyPage.pageSize" layout="total, prev, pager, next, jumper" :total="surveyPage.totalRows">
        </el-pagination>
        <div slot="footer" class="dialog-footer t-right">
          <el-button plain size="medium" @click="visible4 = false">取消</el-button>
          <el-button size="medium" type="info" @click="submitFormSurvey">确定</el-button>
        </div>
      </el-dialog>
    </div>

    <!-- N7 行级化：标注行"标注人员要求"设置弹框（02sheet 示意图口径：明细表"去设置"入口，非必填；
         详情态已设置行显示"查看"入口，弹框转只读（控件禁用+仅关闭按钮）；
         含标签模板（行级必填项，后端 S0017）+ 预标注模型 + 人员要求区，字段与协配页标注表单同源；
         注意置于 v-if 容器之外，弹框须常驻渲染由 sjbzReqVisible 控制显隐） -->
    <el-dialog :title="sjbzReqTitle" :visible.sync="sjbzReqVisible" width="960px" top="8vh" :close-on-click-modal="false"
      :fullscreen="!sjbzReqReadonly" :custom-class="sjbzReqReadonly ? '' : 'sjbz-req-dialog'" append-to-body>
      <el-form v-if="!sjbzReqReadonly" label-position="top" class="sjbz-req-editor">
        <section class="sjbz-personnel-panel">
          <div class="sjbz-personnel-heading">
            <div class="sjbz-req-subtitle">标注人员要求<span class="sjbz-req-tip">（均非必填，下发时按此过滤候选人员）</span></div>
            <el-button type="text" size="small" :aria-expanded="String(sjbzPersonnelExpanded)"
              @click="sjbzPersonnelExpanded = !sjbzPersonnelExpanded">{{ sjbzPersonnelExpanded ? '收起' : '展开' }}
              <i :class="sjbzPersonnelExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
            </el-button>
          </div>
          <div v-show="sjbzPersonnelExpanded" class="sjbz-personnel-fields">
            <el-form-item label="所属科室">
              <el-cascader v-model="sjbzReqForm.deptGuid" :options="sjbzDeptTree" :props="sjbzDeptProps"
                :show-all-levels="false" placeholder="该科室及下级均符合" clearable @change="onSjbzDeptChange"></el-cascader>
            </el-form-item>
            <el-form-item label="标注人员身份">
              <el-select v-model="sjbzReqForm.identity" placeholder="请选择" clearable @change="onSjbzIdentityChange">
                <el-option v-for="item in sjbzIdentityOptions" :key="item.value" :label="item.text" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="sjbzReqTitleLabel">
              <el-select v-if="sjbzReqForm.identity !== '5'" ref="sjbzTitleSelect" v-model="sjbzReqForm.titleGuids"
                multiple collapse-tags placeholder="请选择（按身份联动）" clearable>
                <el-option v-for="item in sjbzTitleOptions" :key="item.guid" :label="item.dicName" :value="item.guid"></el-option>
              </el-select>
              <el-cascader v-else v-model="sjbzReqForm.majorGuid" :options="sjbzDeptTree" :props="sjbzDeptProps"
                :show-all-levels="false" placeholder="请选择专业" clearable @change="onSjbzMajorChange"></el-cascader>
            </el-form-item>
            <el-form-item label="标注经验">
              <el-input v-model="sjbzReqForm.experience" maxlength="100" placeholder="请输入，如：3年以上影像标注经验"></el-input>
            </el-form-item>
          </div>
        </section>
        <label-prelabel-preview :active="sjbzReqVisible" :text-task="sjbzReqIsText"
          :model-guid="sjbzReqForm.modelGuid" :model="sjbzSelectedModel" :label-snapshots="sjbzReqForm.labelSnapshots"
          :labels-loading="sjbzTemplatesLoading" :selection-revision="sjbzTemplateSelectionVersion">
          <el-form-item label="模型选择">
            <el-select v-model="sjbzReqForm.modelGuid" placeholder="请选择预标注模型（选填）" filterable clearable @change="onSjbzModelChange">
              <el-option v-for="item in sjbzModelOptions" :key="item.guid" :label="item.modelName + '（' + item.labelTypeName + '）'" :value="item.guid"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择标签" required>
            <div class="sjbz-label-rows">
              <div v-for="(snap, idx) in sjbzReqForm.labelSnapshots" :key="sjbzTemplateRowKeys[idx]" class="sjbz-preview-label-row">
                <label-template-select :value="sjbzReqForm.labelSnapshots[idx]" stacked descriptive-label :guard-selection="sjbzReqVisible"
                  @selection-state="onSjbzTemplateSelection"
                  @input="(v) => $set(sjbzReqForm.labelSnapshots, idx, v)" :data-modal-guid="sjbzReqDataModalGuid">
                  <el-button slot="actions" type="text" class="danger sjbz-label-del"
                    @click="removeSjbzTemplateRow(idx)">删除</el-button>
                </label-template-select>
              </div>
              <el-button type="text" icon="el-icon-plus" size="mini" @click="addSjbzTemplateRow">添加</el-button>
              <div v-if="sjbzSelectionCount > maxTaskLabels && sjbzReqRow && sjbzReqRow._sourceTaskDetailGuid" class="sjbz-label-capacity-tip">历史标签未修改时，提交由系统校验原快照</div>
            </div>
          </el-form-item>
        </label-prelabel-preview>
      </el-form>
      <!-- 详情态：纯详情共用组件（2026-09-16 受理页交互改造抽出 LabelReqView，两处复用） -->
      <label-req-view v-else :conf="sjbzReqForm"></label-req-view>
      <div slot="footer" class="dialog-footer">
        <template v-if="sjbzReqReadonly">
          <el-button size="small" type="primary" @click="sjbzReqVisible = false">关 闭</el-button>
        </template>
        <template v-else>
          <span class="sjbz-preview-footer-tip">预览文本与结果不写入正式标注数据</span>
          <el-button size="small" @click="sjbzReqVisible = false">取 消</el-button>
          <el-button size="small" type="primary" :disabled="sjbzTemplatesLoading" @click="sjbzReqSure">确 定</el-button>
        </template>
      </div>
    </el-dialog>
    <!-- 限制品种弹窗 开始 -->
    <GoodsLimitSelect :disabled="disabled" @getLimitProducts="getLimitProducts" :sendTenantGuid="sendTenantGuid"
      :taskList="tableData" :taskIndex="currentIndex" :showFromLevel="visible2" @closeGoodsLimit="visible2 = false">
    </GoodsLimitSelect>
    <!-- 限制品种弹窗 结束 -->
  </div>
</template>

<script>
import  GoodsLimitSelect from './GoodsLimitSelect';
import { provinceAndCityData } from 'element-china-area-data'
import store from '@/store';
import LabelTemplateSelect from '@/views/certManagement/components/LabelTemplateSelect.vue';
import LabelReqView from '@/views/taskMangement/components/LabelReqView.vue';
import LabelPrelabelPreview from '@/views/certManagement/components/LabelPrelabelPreview.vue';
import { isTextPreviewModality } from '@/uilt/prelabelPreviewApi';
import { getPlatformDeptTenantGuid } from '@/uilt/platformDeptGuid';
import { countTaskLabels, MAX_TASK_LABELS, sameTaskSnapshots, hasInvalidTaskSnapshots } from '@/uilt/labelTaskCapacity';
export default {
  components:{
    GoodsLimitSelect,
    LabelTemplateSelect,
    LabelReqView,
    LabelPrelabelPreview
  },
  data() {
    return {
      maxTaskLabels: MAX_TASK_LABELS,
      limitTaskDicts:[],
      taskLabelListList: [],
      taskLabelVal: '',
      delFlag: false,
      serviceTenantGuid: '', //服务商id
      serviceTenantName: '', //服务商名称
      fullscreenLoading: false,
      textTitle: '新增任务大类',
      organisationList: [],
      tenantList: [],
      sendTenantList: [], //委托方
      taskTypeList: [],
      taskContentList: [],
      taskReqList: [],
      taskTotalUnitList: [],
      taskPriceUnitList: [],
      clientObjectList: [],
      clientObject: [],
      clientAreaRadio: '不限区域',
      clientArea: '',
      clientAreaLabel: [],
      templateName: '',
      taskType: '',
      taskContentName: '',
      tenantName: '',
      taskTag: [],
      taskTotal: '',
      taskTotalUnit: '',
      taskTotalUnitGuid: '',
      taskPrice: '',
      taskPriceUnit: '',
      taskPriceUnitGuid: '',
      taskNote: '',
      height: window.innerHeight - 260,
      right: 'right',
      tableData: [],
      dialogVisible: false,

      visible3: false,
      area: [],
      departmentList: [],
      departmentData: '',
      areaData: [],
      delList: [],
      filterText: '',
      defaultProps: {
        id: 'guid',
        label: 'organisationName',
        children: 'children',
        disabled: this.disabledTreeNode,
      },

      visible2: false,
      pageII: {
        pageIndex: 1,
        tenantGuid: '',
        pageSize: 10,
        goodsName: '',
        isPrescription: '',
        staffGuid: '',
        totalPage: 0,
        totalRows: 0,
      },
      productInformationList: [],
      multipleSelection: [],

      loading: false,
      provinceAndCityData: provinceAndCityData,
      provinceArray: [
        { name: '北京', code: 110000 },
        { name: '天津', code: 120000 },
        { name: '河北', code: 130000 },
        { name: '山西', code: 140000 },
        { name: '内蒙古', code: 150000 },
        { name: '辽宁', code: 210000 },
        { name: '吉林', code: 220000 },
        { name: '黑龙江', code: 230000 },
        { name: '上海', code: 310000 },
        { name: '江苏', code: 320000 },
        { name: '浙江', code: 330000 },
        { name: '安徽', code: 340000 },
        { name: '福建', code: 350000 },
        { name: '江西', code: 360000 },
        { name: '山东', code: 370000 },
        { name: '河南', code: 410000 },
        { name: '湖北', code: 420000 },
        { name: '湖南', code: 430000 },
        { name: '广东', code: 440000 },
        { name: '广西', code: 450000 },
        { name: '海南', code: 460000 },
        { name: '重庆', code: 500000 },
        { name: '四川', code: 510000 },
        { name: '贵州', code: 520000 },
        { name: '云南', code: 530000 },
        { name: '西藏', code: 540000 },
        { name: '陕西', code: 610000 },
        { name: '甘肃', code: 620000 },
        { name: '青海', code: 630000 },
        { name: '宁夏', code: 640000 },
        { name: '新疆', code: 650000 },
      ],
      currentIndex: 0, //当前操作行
      // ===== N7 行级化：标注行三列交互态（含 SJBZ 行的表格才启用，普通表格零加载零影响） =====
      sjbzDatasetOptions: [], //选择标注数据下拉候选（仅待标注 N 态；懒加载）
      sjbzDatasetLoaded: false,
      sjbzReqVisible: false, //标注人员要求弹框
      sjbzPersonnelExpanded: true,
      sjbzTemplateLoads: {},
      sjbzTemplateSelectionVersion: 0,
      sjbzTemplateRowKeys: [],
      sjbzTemplateRowSequence: 0,
      sjbzReqRow: null, //弹框当前操作行（SJBZ 行引用）
      sjbzReqForm: {
        labelSnapshots: [null], //S1(review)：初始即数组，防直开弹框 TypeError modelGuid: '', modelName: '',
        deptGuid: '', deptName: '', identity: '', titleGuids: [],
        majorGuid: '', majorName: '', experience: '',
      },
      sjbzModelOptions: [], sjbzDeptTree: [], sjbzTitleTree: [], sjbzIdentityOptions: [],
      sjbzReqLoaded: false, //弹框候选（模型/科室/职称/身份）懒加载标记
      sjbzReqReadonly: false, //弹框只读态（详情态"查看"入口，控件禁用只留关闭）
      sjbzDeptProps: { value: 'guid', label: 'deptName', children: 'childList', checkStrictly: true, emitPath: false },
      calcTypeList: ['系统计算', '固定量人均', '按学术活动计划', '不限量'],
      detail: null,
      url: `/${serverConfig.msCommonAdminCloudService}/obs/upload-file`,
      urlImg: `/${serverConfig.msCommonAdminCloudService}/obs/upload-image`,
      token: {
        'Content-Type': 'multipart/form-data',
        Authorization: store.state.token,
      },
      iconVisible: false,
      iconList: [],
      activeIcon: 0,
      chooseURL: null,
      waitDelTemplate: [],
      visible4: false,
      surveyObj: {},
      surveyList: [],
      surveyLabelOptions: [],
      surveyPage: {
        // bizApproveState: 'Y',
        isDraft: 'N',
        pageIndex: 1,
        surveyTenantGuid: '',
        pageSize: 10,
        surveyState: 'Y',
        // isDraft:'Y',
        surveyTitle: '',
        isShowPlatformTemplate:'Y'

      }
    };
  },
  computed: {
    sjbzSelectionCount() {
      return countTaskLabels(this.sjbzReqForm.labelSnapshots);
    },
    sjbzSelectionTemplateCount() {
      return (this.sjbzReqForm.labelSnapshots || []).filter(Boolean).length;
    },
    tableHeight() {
      return this.tableData.length > 8 ? '600px' : '';
    },
    // N7 行级化：表格是否含标注行（含才渲染标注三列，普通任务表格零影响）
    hasSjbzRows() {
      return this.tableData.some((row) => this.isSjbzRow(row));
    },
    // 标注三列可交互态：FOUR-3019 仅完整编辑态（新建页）可改——修改任务包页（确认人部分可
    // 编辑态 isPartDisabled）标注三列（选择标注数据/标注人员要求/质检比例）只读，反转 09-21 口径；
    // isPartDisabled 总开关不动：修改页任务名行内编辑/"更多"弹框任务量与区域等确认人域保持原状
    sjbzEditable() {
      return !this.disabled;
    },
    // 行级"更多"弹框三域可编辑态：仅标注行放开（普通行维持原有只读），同上仅完整编辑态
    sjbzNoteEditable() {
      return this.isSjbzRow(this.tableData[this.currentIndex]) && !this.disabled;
    },
    // 标注人员要求弹框标题与联动字段
    sjbzReqTitle() {
      const name = this.sjbzReqRow ? this.sjbzReqRow.taskContentName : '';
      return name ? `【${name}】标注人员要求` : '标注人员要求';
    },
    sjbzReqTitleLabel() {
      return this.sjbzReqForm.identity === '5' ? '标注人员专业' : '标注人员职称';
    },
    sjbzSelectedModel() {
      return this.sjbzModelOptions.find(item => item.guid === this.sjbzReqForm.modelGuid) || null;
    },
    sjbzTemplatesLoading() {
      return Object.keys(this.sjbzTemplateLoads).length > 0;
    },
    sjbzReqIsText() {
      const conf = this.sjbzReqRow ? this.sjbzConf(this.sjbzReqRow) : {};
      const dataset = this.sjbzDatasetOptions.find(item => item.guid === conf.datasetGuid) || {};
      const snapshot = (this.sjbzReqForm.labelSnapshots || []).find(Boolean) || {};
      return isTextPreviewModality(this.sjbzReqDataModalGuid || snapshot.dataModalGuid,
        conf.dataModalName || dataset.dataModalName || snapshot.dataModalName);
    },
    sjbzTitleOptions() {
      const groupName = { '1': '医生职称', '2': '护士职称', '3': '药师职称', '4': '技师职称' }[this.sjbzReqForm.identity];
      if (!groupName) return [];
      const group = (this.sjbzTitleTree || []).find((item) => item.dicName === groupName);
      return group && group.childList ? group.childList : [];
    },
    // 已选职称全量文案（collapse-tags 折叠后供原生 title 悬停展示）
    sjbzTitleTagsText() {
      return this.sjbzReqForm.titleGuids
        .map((guid) => {
          const hit = this.sjbzTitleOptions.find((item) => item.guid === guid);
          return hit ? hit.dicName : '';
        })
        .filter(Boolean)
        .join('、');
    },
    // 详情态纯文本视图已抽为共用组件 LabelReqView（身份文案/职称全量由组件按快照解析）
    // 标签模板下拉按该行数据集模态联动过滤（未选数据集时不过滤）
    sjbzReqDataModalGuid() {
      if (!this.sjbzReqRow) return '';
      const conf = this.sjbzConf(this.sjbzReqRow);
      if (conf.dataModalGuid) return conf.dataModalGuid;
      // FOUR-3006：旧数据 labelConfig 无模态字段时按 datasetGuid 从候选反查（数据集保存必填模态，反查可靠）
      if (conf.datasetGuid) {
        const hit = (this.sjbzDatasetOptions || []).find((item) => item.guid === conf.datasetGuid);
        if (hit && hit.dataModalGuid) return hit.dataModalGuid;
      }
      return '';
    },
  },
  props: ['configData', 'disabled', 'sendTenantGuid', 'sendTenantName', 'isPartDisabled', 'taskPriceDisabled', 'organisationInfo', 'startTime', 'endTime', 'autoForecastOpen','taskPriceModel', 'datasetTenantGuids'],
  created() {
    console.log(12,this.$route.query,this.$props.taskPriceDisabled)
    this.$props.taskPriceDisabled=this.$props.taskPriceDisabled||false
    let userInfo = JSON.parse(localStorage.userInfo);
    this.serviceTenantName = userInfo.tenantName;
    this.serviceTenantGuid = localStorage.guid;

    this.getHeartDictList();
    this.getSendTenantList();
    this.getTaskTypeList();
    this.getTaskTotalUnitList();
    this.getTaskPriceUnitList();
    // this.getCustomerType();
    this.getIconList();
    this.getLabelOrCreate();
    this.getLevelList();
    console.log(this.autoForecastOpen)
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    // 委托方切换/详情回显后重置科室树懒加载标记：候选池=委托方认证人员，按其租户科室树过滤，
    // 用登录租户的树选出的科室 guid 跨体系对候选过滤永无命中（09-18 测试库实证），下次打开弹框按委托方重载
    sendTenantGuid() {
      this.sjbzReqLoaded = false;
      this.sjbzDeptTree = [];
    },
    // N7 行级化：出现标注行才懒加载数据集候选（普通任务表格零请求）
    hasSjbzRows(val) {
      if (val && !this.sjbzDatasetLoaded) {
        this.loadSjbzDatasets();
      }
    },
    // Element UI collapse-tags 无内置 tooltip：已选职称变化或弹框打开时，把全量文案挂到折叠标签容器原生 title 上
    sjbzTitleTagsText() {
      this.$nextTick(this.applySjbzTitleTagTitle);
    },
    sjbzReqVisible(val) {
      if (val) this.$nextTick(this.applySjbzTitleTagTitle);
      else this.sjbzTemplateLoads = {};
    },
    configData: {
      deep: true,
      handler(val) {
        this.getDetail(val);
      },
    },
    sendTenantGuid(newVal, oldVal) {
      if (newVal != oldVal && oldVal) {
        var tableData = this.tableData;
        tableData.forEach(item => {
          item.multipleSelection = []
        })
        this.tableData = tableData;
        // I2(review)：数据集候选随委托方切换重载（2996 行级侧闭环；2996 协配页侧已由父组件处理）
        this.sjbzDatasetLoaded = false;
        this.sjbzDatasetOptions = [];
        if (this.hasSjbzRows) {
          this.loadSjbzDatasets();
        }
      }
    },
  },
  methods: {
    // N7 行级化：判定标注明细行（含才渲染标注三列，普通任务表格零影响）
    isSjbzRow(row) {
      return row && row.taskContentType === 'SJBZ';
    },
    // SJBZ 行计算方式可选项收窄（2026-09-29 拍板）：仅固定量人均（人均定人数）与系统计算
    // （总量=数据集数据量）两态有标注语义；不限量/按学术活动计划对标注行无意义且会破坏量口径
    calcTypeOptions(row) {
      if (!this.isSjbzRow(row)) return this.calcTypeList;
      return this.calcTypeList.filter((t) => t === '固定量人均' || t === '系统计算');
    },
    // 标注行 labelConfig 解析（解析失败降级空对象；$set 使配置对象响应式，列内交互改动可实时生效）
    sjbzConf(row) {
      if (!row) return {};
      if (!row.__sjbzConf) {
        let conf;
        let invalidConfig = false;
        try {
          conf = row.labelConfig ? JSON.parse(row.labelConfig) : {};
          if (!conf || typeof conf !== 'object' || Array.isArray(conf)) {
            conf = {};
            invalidConfig = true;
          }
        } catch (e) {
          conf = {};
          invalidConfig = true;
        }
        // FOUR-3000：编辑态下行级质检比例缺省补 100（新行不再空着等提交报错）；
        // 只读态不补——行级化前的旧包比例在顶层，行级缺值显示 '-' 不虚构。
        // 缺省补值只在首次解析时机做一次：若放在渲染路径（本方法被 v-model 每次渲染
        // 调用），用户清空输入触发重渲染时会被强制弹回 100 并写回 labelConfig，
        // 输入框表现为"数字改不了"；清空后的兜底由失焦校验 onSjbzRatioChange 恢复
        if (this.sjbzEditable && this.isSjbzRow(row) && !invalidConfig && !hasInvalidTaskSnapshots(conf)
          && (conf.qcRatio == null || conf.qcRatio === '')) {
          conf.qcRatio = 100;
          row.labelConfig = JSON.stringify(conf);
        }
        this.$set(row, '__sjbzInvalidConfig', invalidConfig);
        this.$set(row, '__sjbzConf', conf);
      }
      return row.__sjbzConf;
    },
    // 标注行配置写回（改动后同步序列化回 row.labelConfig，随明细提交）
    // FOUR-3006：禁止 Object.assign 原地补键——conf 经 $set 挂载时只 walk 已有键，
    // 后补的新键（dataModalGuid/datasetGuid/labelSnapshots…）非响应式，消费方 computed
    // （sjbzReqDataModalGuid 模态联动/一致性校验）读到缓存空值致联动失效、校验静默放行；
    // 改为合并出新对象后 $set 整体重挂，新键随重挂转响应式
    updateSjbzConf(row, patch) {
      const conf = this.sjbzConf(row);
      if (row.__sjbzInvalidConfig || hasInvalidTaskSnapshots(conf)) {
        this.$message.error('原任务标签快照格式异常，请核查原任务后重试');
        return;
      }
      const next = { ...conf, ...patch };
      row.labelConfig = JSON.stringify(next);
      this.$set(row, '__sjbzConf', next);
    },
    // ===== 选择标注数据列 =====
    sjbzDatasetLabel(item) {
      return item.dataAmount !== '' && item.dataAmount != null
        ? `${item.datasetName}（${item.dataAmount}${item.dataUnit || ''}）`
        : item.datasetName;
    },
    loadSjbzDatasets() {
      this.sjbzDatasetLoaded = true;
      // 宿主传 datasetTenantGuids（工作任务派发-02：委托方+服务方双池，2026-09-21）时按多租户池查
      // （后端 FOUR-2996 tenantGuids 非空优先）；未传的宿主维持 FOUR-3010 单值口径（登录企业）
      let query;
      const dualPool = (this.datasetTenantGuids || []).filter(Boolean);
      if (dualPool.length) {
        const pools = [];
        dualPool.forEach((guid) => {
          if (pools.indexOf(guid) < 0) pools.push(guid);
        });
        query = { tenantGuids: pools, dataStatus: 'N', pageIndex: 1, pageSize: 100 };
      } else {
        query = { tenantGuid: localStorage.guid, dataStatus: 'N', pageIndex: 1, pageSize: 100 };
      }
      this.api.postJson(`/${serverConfig.msSalesPerformService}/label-dataset/page-list`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.sjbzDatasetOptions = res.data.data.records || [];
          this.ensureSjbzDatasetOptions();
        }
      });
    },
    // 已保存数据集可能已流转非待标注态（不在候选列表），补项保留下拉回显
    ensureSjbzDatasetOptions() {
      this.tableData.filter((row) => this.isSjbzRow(row)).forEach((row) => {
        const conf = this.sjbzConf(row);
        if (conf.datasetGuid && !this.sjbzDatasetOptions.some((item) => item.guid === conf.datasetGuid)) {
          this.sjbzDatasetOptions.unshift({
            guid: conf.datasetGuid, datasetName: conf.datasetName || conf.datasetGuid,
            dataAmount: conf.dataAmount != null ? conf.dataAmount : '',
            dataUnit: conf.dataUnit || '', dataModalGuid: conf.dataModalGuid || '', dataModalName: conf.dataModalName || '',
          });
        }
      });
    },
    onSjbzDatasetChange(row) {
      const conf = this.sjbzConf(row);
      if (row.__sjbzInvalidConfig || hasInvalidTaskSnapshots(conf)) {
        try { conf.datasetGuid = JSON.parse(row.labelConfig).datasetGuid || ''; } catch (e) { /* 原配置无法解析时不写回 */ }
        this.$message.error('原任务标签快照格式异常，请核查原任务后重试');
        return;
      }
      // FOUR-3006 场景8（复测打回）：旧模态以"已选标签快照的模态"兜底——未选数据集时
      // conf.dataModalGuid 为空，直接与新数据集模态比较会把用户已选的同模态标签误清空
      //（例：未选数据集→选文本模态模板→再选文本模态数据集，应保留标签）
      const pickedSnaps = (conf.labelSnapshots && conf.labelSnapshots.length
        ? conf.labelSnapshots : [conf.labelSnapshot]).filter(Boolean);
      const snapModal = pickedSnaps.map((s) => s && s.dataModalGuid).find(Boolean) || '';
      const oldModalGuid = conf.dataModalGuid || snapModal;
      const hit = this.sjbzDatasetOptions.find((item) => item.guid === conf.datasetGuid) || {};
      this.updateSjbzConf(row, {
        datasetGuid: hit.guid || '',
        datasetName: hit.datasetName || '',
        dataAmount: hit.dataAmount != null && hit.dataAmount !== '' ? +hit.dataAmount : null,
        dataUnit: hit.dataUnit || '',
        dataModalGuid: hit.dataModalGuid || '',
        dataModalName: hit.dataModalName || '',
      });
      // FOUR-3006：数据模态变更后已选标签全部清空（口径：全部清空，按新模态重选）；清除时一并清旧单标签字段
      if (oldModalGuid !== (hit.dataModalGuid || '')
        && ((conf.labelSnapshots || []).length || conf.labelSnapshot)) {
        this.updateSjbzConf(row, { labelSnapshots: [], labelSnapshot: undefined });
      }
      // 任务量联动按计算方式分流：固定量人均=人均语义不联动（换数据集旧人均仍有效，方案§二.5，
      // 联动预填条数会把总量当人均提交）；系统计算=总量语义，输入框值从标注数据的数据量带出
      if (row.calcType == '系统计算') {
        row.taskTotal = hit.dataAmount != null && hit.dataAmount !== '' ? +hit.dataAmount : row.taskTotal;
      }
      row.taskTotalUnit = hit.dataUnit || row.taskTotalUnit;
    },
    // ===== 质检比例列（0<x≤100 整数，默认 100） =====
    onSjbzRatioChange(row) {
      const ratio = +this.sjbzConf(row).qcRatio;
      if (!Number.isInteger(ratio) || ratio <= 0 || ratio > 100) {
        this.$message.warning('质检比例须为 0~100 的整数，已恢复默认 100');
        this.updateSjbzConf(row, { qcRatio: 100 });
        return;
      }
      this.updateSjbzConf(row, { qcRatio: ratio });
    },
    // ===== 标注人员要求弹框 =====
    sjbzReqSet(row) {
      const conf = this.sjbzConf(row);
      return !!(conf.labelSnapshot || (conf.labelSnapshots && conf.labelSnapshots.length) || conf.modelGuid
        || conf.deptGuid || conf.identity
        || (conf.titleGuids && conf.titleGuids.length) || conf.majorGuid || conf.experience);
    },
    // 把已选职称全量文案挂到折叠标签容器原生 title（Element UI collapse-tags 无内置 tooltip）
    applySjbzTitleTagTitle() {
      const sel = this.$refs.sjbzTitleSelect;
      if (!sel || !sel.$el) return;
      const tags = sel.$el.querySelector('.el-select__tags');
      if (tags) tags.setAttribute('title', this.sjbzTitleTagsText);
    },
    openSjbzReq(row, readonly) {
      const conf = this.sjbzConf(row);
      if (row.__sjbzInvalidConfig || hasInvalidTaskSnapshots(conf)) {
        this.$message.error('原任务标签快照格式异常，请核查原任务后重试');
        return;
      }
      this.sjbzReqRow = row;
      this.sjbzReqReadonly = !!readonly;
      this.sjbzPersonnelExpanded = true;
      this.sjbzTemplateLoads = {};
      this.loadSjbzReqOptions();
      this.sjbzReqForm = {
        // C1(review)：深拷贝快照数组，防弹框内删改直接写共享引用、"取消"后随下次提交落库
        labelSnapshots: conf.labelSnapshots && conf.labelSnapshots.length
          ? conf.labelSnapshots.map((snap) => (snap ? JSON.parse(JSON.stringify(snap)) : snap))
          : (conf.labelSnapshot ? [JSON.parse(JSON.stringify(conf.labelSnapshot))] : [null]),
        modelGuid: conf.modelGuid || '',
        modelName: conf.modelName || '',
        deptGuid: conf.deptGuid || '',
        deptName: conf.deptName || '',
        identity: conf.identity || '',
        titleGuids: (conf.titleGuids || []).slice(),
        titleNames: (conf.titleNames || []).slice(),
        majorGuid: conf.majorGuid || '',
        majorName: conf.majorName || '',
        experience: conf.experience || '',
      };
      // 行身份只留在弹框内，删除其他行时保留本行在途详情，不进入任务快照。
      this.sjbzTemplateRowKeys = this.sjbzReqForm.labelSnapshots.map(() => ++this.sjbzTemplateRowSequence);
      this.sjbzReqVisible = true;
    },
    // 弹框候选（模型/科室树/职称树/身份字典）懒加载，打开时才请求
    loadSjbzReqOptions() {
      if (this.sjbzReqLoaded) return;
      this.sjbzReqLoaded = true;
      this.api.postJson(`/${serverConfig.msSalesPerformService}/prelabel-model/page-list`, {
        tenantGuid: localStorage.guid, enableState: 'Y', pageIndex: 1, pageSize: 100,
      }).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.sjbzModelOptions = res.data.data.records || [];
        }
      });
      // 科室树（统一口径：平台租户的 mf_med_dept 树——医院科室是配置表业务非字典，
      // 环境分支同小程序 getPlatformGuid）
      this.api.get(`/${serverConfig.msPersonnelService}/staff-cert/dept-tree?tenantGuid=${getPlatformDeptTenantGuid()}`).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.sjbzDeptTree = res.data.data || [];
        }
      });
      this.api.get(`/${serverConfig.msConfigureService}/dict/get-tree-by-dictType?dictType=职称`).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.sjbzTitleTree = res.data.data || [];
        }
      });
      this.sjbzIdentityOptions = this.getCodeListByKey('认证身份') || [];
    },
    onSjbzModelChange(guid) {
      const hit = this.sjbzModelOptions.find((item) => item.guid === guid);
      this.sjbzReqForm.modelName = hit ? hit.modelName : '';
    },
    onSjbzTemplateSelection({ selectorId, pending, changed }) {
      if (!this.sjbzReqVisible || this.sjbzReqReadonly) return;
      if (pending) this.$set(this.sjbzTemplateLoads, selectorId, true);
      else this.$delete(this.sjbzTemplateLoads, selectorId);
      if (changed) this.sjbzTemplateSelectionVersion += 1;
    },
    addSjbzTemplateRow() {
      this.sjbzReqForm.labelSnapshots.push(null);
      this.sjbzTemplateRowKeys.push(++this.sjbzTemplateRowSequence);
    },
    removeSjbzTemplateRow(index) {
      this.sjbzReqForm.labelSnapshots.splice(index, 1);
      this.sjbzTemplateRowKeys.splice(index, 1);
    },
    onSjbzIdentityChange() {
      this.sjbzReqForm.titleGuids = [];
      this.sjbzReqForm.majorGuid = '';
      this.sjbzReqForm.majorName = '';
    },
    // 任意层级单选=该科室及下级均符合（checkStrictly）
    onSjbzDeptChange(guid) {
      this.sjbzReqForm.deptGuid = guid || '';
      this.sjbzReqForm.deptName = this.findDeptName(this.sjbzDeptTree, guid);
    },
    onSjbzMajorChange(guid) {
      this.sjbzReqForm.majorGuid = guid || '';
      this.sjbzReqForm.majorName = this.findDeptName(this.sjbzDeptTree, guid);
    },
    findDeptName(nodes, guid) {
      for (const node of nodes || []) {
        if (node.guid === guid) return node.deptName;
        const hit = this.findDeptName(node.childList, guid);
        if (hit) return hit;
      }
      return '';
    },
    sjbzReqSure() {
      if (this.sjbzTemplatesLoading) {
        this.$message.error('标签详情加载中，请稍候再确认');
        return;
      }
      // FOUR-3001：多标签，过滤空行后至少一个
      const labelSnapshots = (this.sjbzReqForm.labelSnapshots || []).filter(Boolean);
      if (!labelSnapshots.length) {
        this.$message.error('请选择标签模板');
        return;
      }
      const labelCount = countTaskLabels(labelSnapshots);
      if (labelCount > MAX_TASK_LABELS && !sameTaskSnapshots(labelSnapshots, this.sjbzConf(this.sjbzReqRow))) {
        this.$message.error(`单条标注任务最多选择${MAX_TASK_LABELS}个标签，当前${labelCount}个，请调整标签`);
        return;
      }
      // 模态一致性：每个标签模板与该行数据集模态（三方一致性约束，与协配页口径一致）
      const dataModalGuid = this.sjbzReqDataModalGuid;
      for (const snapshot of labelSnapshots) {
        if (snapshot.dataModalGuid && dataModalGuid && snapshot.dataModalGuid !== dataModalGuid) {
          this.$message.error('标签模板与所选数据集的数据模态不一致，请重新选择');
          return;
        }
      }
      const titleNames = this.sjbzReqForm.titleGuids.map((guid) => {
        const hit = this.sjbzTitleOptions.find((item) => item.guid === guid);
        return hit ? hit.dicName : '';
      }).filter(Boolean);
      this.updateSjbzConf(this.sjbzReqRow, {
        labelSnapshots,
        labelSnapshot: undefined, // S2(review)：新写不再携带旧单标签字段，消除双字段二义
        modelGuid: this.sjbzReqForm.modelGuid,
        modelName: this.sjbzReqForm.modelName,
        deptGuid: this.sjbzReqForm.deptGuid,
        deptName: this.sjbzReqForm.deptName,
        identity: this.sjbzReqForm.identity,
        titleGuids: this.sjbzReqForm.titleGuids.slice(),
        titleNames,
        majorGuid: this.sjbzReqForm.majorGuid,
        majorName: this.sjbzReqForm.majorName,
        experience: this.sjbzReqForm.experience,
      });
      this.sjbzReqVisible = false;
    },
    // 更新标签
    updateLabels(value, row) {
      if (value?.length > 3) {
        this.$message.warning('最多只能选择3个标签');
        
        // 保存当前行的原始值
        const originalValue = [...(row.surveyLabelList || [])];
        
        if (originalValue.length >= 3) {
          // 已经有3个，恢复原来的值
          this.$nextTick(() => {
            // 使用 Vue.set 确保响应式更新
            this.$set(row, 'surveyLabelList', originalValue);
          });
        } else {
          // 还没有3个
          this.$nextTick(() => {
            this.$set(row, 'surveyLabelList', value);
          });
        }
      } else {
        this.$set(row, 'surveyLabelList', value || []);
      }
    },
    getSurveyLabelNames(values) {
      if (!values?.length) {
        return '-';
      }
      
      const names = values
        .map(value => this.surveyLabelMap[value])
        .filter(name => name);
      
      return names.join('、');
    },
    // 构建映射关系
    getSurveyLabelMap(data) {
      const surveyMap = {};
      const traverse = (items) => {
        items.forEach(item => {
          surveyMap[item.value] = item.text;
          if (item.childDictList?.length) {
            traverse(item.childDictList);
          }
        });
      };
      traverse(data);
      return surveyMap;
    },
    async getHeartDictList() {
      const params = {
        name: "项目标签",
      };
      const { data } = await this.api.get(
        `/${serverConfig.msSalesPerformService}/common/get-heart-dict`,
        params
      );
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      this.surveyLabelOptions = data.data.map(item => {
        return {
          ...item,
          disabled: true,
        }
      })
      this.surveyLabelMap = this.getSurveyLabelMap(data.data);
    },
    checkDiscountRatio(row,index){
      if(!row.discountRatio||row.discountRatio == '0') {
        this.tableData[index].checkDiscountMsg = '';
        this.tableData[index].discountRatio = '';
      }
      let query = {
        templateDetailGuid:row.guid,
        serviceTenantGuid: this.serviceTenantGuid,
        tenantGuid: this.sendTenantGuid,
        discountRatio:row.discountRatio
      };
      this.api.postJson(`/${serverConfig.msSalesPerformService}/task-set/template/check-discount-ratio`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.tableData[index].checkDiscountMsg = res.data.data;
          this.$forceUpdate()
          console.log(row);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    renderHeader: function (h, { column, $index }) {
      return [
        column.label,
        h(
          'el-tooltip',
          {
            props: {
              placement: 'top',
              effect: 'dark',
              //content:"提示框内容",//如果提示内容短不需要换行，直接使用这个提示内容
            },
          },
          [
            h(
              'div',
              {
                //当前div是为了实现换行，就这换行研究了好久。。。
                slot: 'content',
              },
              [
              '药企端查看的任务价格单位，仅供展示'
              ],
            ),
            h('span', {
              //问号模块
              class: {
                'el-icon-question': true,
              },
            }),
          ],
        ),
      ];
    },
    renderHeaderII: function (h, { column, $index }) {
      return [
        column.label,
        h(
          'el-tooltip',
          {
            props: {
              placement: 'top',
              effect: 'dark',
              //content:"提示框内容",//如果提示内容短不需要换行，直接使用这个提示内容
            },
          },
          [
            h(
              'div',
              {
                //当前div是为了实现换行，就这换行研究了好久。。。
                slot: 'content',
              },
              [
              '移动端业务员查看的任务价格单位，仅供展示'
              ],
            ),
            h('span', {
              //问号模块
              class: {
                'el-icon-question': true,
              },
            }),
          ],
        ),
      ];
    },
    renderHeaderIII: function (h, { column, $index }) {
      return [
        column.label,
        h(
          'el-tooltip',
          {
            props: {
              placement: 'top',
              effect: 'dark',
              //content:"提示框内容",//如果提示内容短不需要换行，直接使用这个提示内容
            },
          },
          [
            h(
              'div',
              {
                //当前div是为了实现换行，就这换行研究了好久。。。
                slot: 'content',
              },
              [
                '说明: 用于配置任务执行后统计的规则',
                h('br'),
                '比如【拜访医生任务】，单位如下说明：',
                h('br'),
                '1、按人（去重）：一个月拜访两次张三，按拜访 1 人统计，实际结算 500元；',
                h('br'),
                ' 2、按人次（不去重）：一个月拜访两次张三，按实际拜访 2 人 统计，实际结算1000元。',
                h('br'),
                ' 3、按次：提交一条拜访记录则算 1 次，实际结算 500元；',
                h('br'),
                ' 比如【优位陈列任务】，单位如下说明：',
                h('br'),
                '1、按家：一个月拜访 2 家同样的医院，按完成 1 家统计，实际结算 500元；',
                h('br'),
                '2、按家次：目前应用于【万年青】，比如要求拜访某一家药店，必须要每周完成3次拜访，完成后，按 500 元结算。',
                h('br'),
                ' 3、按次：提交一条拜访记录则算 1 次，如果一个月提交 2 次，实际结算 1000元；'
              ]
            ),
            h('span', {
              //问号模块
              class: {
                'el-icon-question': true,
              },
            }),
          ],
        ),
      ];
    },
    handleProvinceAndCity() {
      this.$nextTick(() => {
        let arr = this.$refs['cascaderAddr'].getCheckedNodes()
        let newList = [];
        arr.forEach(item => {
          if (item.level == 1 && item.label == '北京市' || item.level == 1 && item.label == '上海市' || item.level == 1 && item.label == '重庆市' || item.level == 1 && item.label == '天津市') {
            newList.push(item.label)
          } else if (item.level == 2 && item.label != '市辖区' && item.label != '县') {
            newList.push(item.label)
          }
        })
        this.tableData[this.currentIndex].clientAreaLabel = newList

      })
    },
    getSurveyName(obj) {
      if (!obj) return;
      return obj.surveyTitle;
    },
    getPlanCount() {
      var self = this;
      var organisationInfo = this.organisationInfo;
      // console.log(organisationInfo)
      console.log(this.tableData,1)
      // console.log(this.startTime)
      if (!this.organisationInfo || !this.tableData.length || !this.startTime) return;
      this.tableData.forEach((item, index) => {
        if (item.calcType == '按学术活动计划') {
          var req = {
            pageIndex: 1,
            isTeamLeader: item.isTeamLeader,
            organisationInfo,
            pageSize: -1,
            tenantGuid: this.sendTenantGuid,
            startDate: this.startTime + ' ' + '00:00:00',
            endDate: this.endTime + ' ' + '23:59:59',
          };
          self.api
            .postJson(`/${serverConfig.msSalesPerformService}/academic-activity/plan/get-academic-activity-plan-count`, req)
            .then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                item.taskTotal = res.data.data;
                item.calcType = '按学术活动计划'
              } else {
                self.$message.error(res.data.msg);
              }
            }).catch(() => {

            });
        }
      })
    },
    calcTypeChange(index) {
      this.tableData[index].taskTotal = null;
      if (this.tableData[index].calcType == '不限量') {
        this.tableData[index].isOpenMaxTask = false;
        this.tableData[index].maxTaskValue = 0;
      }
      // SJBZ 行切"系统计算"：输入框语义=总量，已选数据集时从数据量带出（与 onSjbzDatasetChange 同口径）
      if (this.tableData[index].taskContentType === 'SJBZ' && this.tableData[index].calcType == '系统计算') {
        const conf = this.sjbzConf(this.tableData[index]);
        if (conf.dataAmount != null && conf.dataAmount !== '') {
          this.tableData[index].taskTotal = +conf.dataAmount;
        }
      }
      this.getPlanCount();
    },
    chooseTemplate() {
      this.$emit('openTemplate');
    },
    seeForecast() {
      this.$emit('seeForecast');
    },
    handleSelectionChange2(v, j) {
      this.waitDelTemplate = v;
    },
    //批量删除模版
    delTemplate() {
      if (this.waitDelTemplate.length == 0) {
        this.$message.error('请选择待删除的任务模版');
        return;
      }
      let guids = [];
      this.waitDelTemplate.forEach(item => {
        guids.push(item.guid);
      })
      this.$emit('delList', guids);
      this.waitDelTemplate.forEach((i, j) => {
        this.tableData.forEach((k, l) => {
          if (i === k) {
            this.tableData.splice(l, 1);
          }
        });
      });
      this.delFlag = true;
    },
    //设置执行规则
    setRule() {
      this.$emit('setRule');
    },
    handleSelecTaskPriceUnit(value, state, index) {
      let taskPriceUnitList = this.taskPriceUnitList;
      let labelItem = taskPriceUnitList.filter(item => item.guid == value)
      if (state == 0) {
        this.tableData[index].taskPriceUnitGuid = value;
      }
      if (state == 1) {
        this.tableData[index].tenantTaskPriceUnitGuid = value;
      }

      this.tableData[index].taskPriceUnit = labelItem[0].paramValue;
      this.tableData[index].tenantTaskPriceUnit = labelItem[0].paramValue;
    },
    handleSelecTaskTotalUnit(value, index) {
      let taskTotalUnitList = this.taskTotalUnitList;
      let labelItem = taskTotalUnitList.filter(item => item.guid == value)
      // console.log(labelItem)
      this.tableData[index].taskTotalUnit = labelItem[0].paramValue;
    },
    moveDown(index) {
      var tableData = JSON.parse(JSON.stringify(this.tableData));
      var temp = tableData[index];
      var temp_1 = tableData[index + 1];
      tableData[index] = temp_1;
      tableData[index + 1] = temp;
      this.tableData = tableData;
      this.$forceUpdate();
    },
    moveUp(index) {
      var tableData = JSON.parse(JSON.stringify(this.tableData));
      var temp = tableData[index];
      var temp_1 = tableData[index - 1];
      tableData[index] = temp_1;
      tableData[index - 1] = temp;
      this.tableData = tableData;
      this.$forceUpdate();
    },
    taskTagChange() {
      var index = this.currentIndex;
      var taskTagList = this.tableData[index].taskTag;
      var taskReqList = this.tableData[index].taskReqList;
      var list = [];
      var resultArr = [];
      taskTagList.forEach((el) => {
        taskReqList.forEach((item) => {
          if (el == item.paramName) {
            list.push(item.paramValue);
          }
        });
      });
      this.tableData[index].staffWorkNote = list.join('\n');
    },
    isContainOrg(arr, guid) {
      if (!arr.length) return 0;
      let flag = arr.findIndex((one) => {
        return one == guid;
      });
      if (flag == -1) {
        return 0;
      } else {
        return 1;
      }
    },
    disabledTreeNode(data, node) {
      let list = this.departmentList;
      if (list.length) {
        let flag = 0;
        let parentGuids = data.parentGuids ? data.parentGuids : [];
        for (let i = 0; i < list.length; i++) {
          let checkedParentGuids = list[i].parentGuids ? list[i].parentGuids : [];
          if (this.isContainOrg(parentGuids, list[i].guid)) {
            flag = 1;
            break;
          } else if (this.isContainOrg(checkedParentGuids, data.guid)) {
            flag = 1;
            break;
          } else {
            flag = 0;
          }
        }
        return flag > 0;
      } else {
        return false;
      }
    },
    searchData() {
      this.getData();
    },
    moreSure() {
      var index = this.currentIndex;
      var tableData = this.tableData;
      // N7 行级化：标注行三域（工作内容描述/明细/任务管理要求）必填，确定即写回该行 labelConfig；
      // 跳过结算比例/任务图标等普通行校验（标注行不涉及）
      if (this.isSjbzRow(tableData[index])) {
        if (!tableData[index].staffTaskNote) {
          this.$message.error('请填写工作内容描述');
          return;
        }
        if (!tableData[index].tenantTaskNote) {
          this.$message.error('请填写工作内容明细');
          return;
        }
        if (!tableData[index].staffWorkNote) {
          this.$message.error('请填写任务管理要求');
          return;
        }
        this.updateSjbzConf(tableData[index], {
          workDesc: tableData[index].staffTaskNote,
          workDetail: tableData[index].tenantTaskNote,
          workRequire: tableData[index].staffWorkNote,
        });
        this.dialogVisible = false;
        return;
      }
      if (tableData[index].settleRule == 2 && !tableData[index].settlePercent) {
        this.$message.error('请输入结算比例');
        return;
      }
      if (!tableData[index].tenantTaskNote) {
        this.$message.error('请填写药企任务文案');
        return;
      }
      if (!tableData[index].staffTaskNote) {
        this.$message.error('请填写业务员任务文案');
        return;
      }
      if (tableData[index].fileList.length == 0) {
        this.$message.error('请上传任务图标');
        return;
      }
      this.dialogVisible = false;
    },
    handleChooseGoods(index) {
      if (!this.sendTenantGuid) {
        this.$message.error('请选择委托方');
        return;
      }
      this.visible2 = true;
      this.currentIndex = index;
      //this.getData();
    },
    handleChooseSurvey(index) {
      if (this.disabled) return;
      if (!this.sendTenantGuid) {
        this.$message.error('请选择委托方');
        return;
      }
      this.visible4 = true;
      this.currentIndex = index;
      this.getSurvey();
    },
    searchSurvey() {
      this.pageIndex = 1,
        this.pageSize = 10,
        this.getSurvey();
    },
    //单选实现
    handleSelectSurvey(selection, row) {
      this.$refs.singleTable.clearSelection();
      if (selection.length == 0) {
        return;
      }
      if (row) {
        this.surveyObj = {
          surveyLabelList: row.surveyLabelList,
          surveyTitle: row.surveyTitle,
          surveyTenantGuid: row.guid
        };
        this.$refs.singleTable.toggleRowSelection(row, true);
      }
    },
    handleClickSurvey(row, col, event) {
      this.$refs.singleTable.clearSelection();
      row.flag = !row.flag;
      this.$refs.singleTable.toggleRowSelection(row, row.flag);
      this.surveyObj = {
        surveyLabelList: row.surveyLabelList,
        surveyTitle: row.surveyTitle,
        surveyTenantGuid: row.guid
      }


      // this.templateSelectd = row;
    },
    submitFormSurvey() {
      if (!this.surveyObj.surveyTenantGuid) {
        this.$message.error('请先选择一个问卷');
        return
      }
      // console.log(this.tableData)
      // console.log(this.currentIndex)
      this.tableData[this.currentIndex].surveyObj = this.surveyObj;
      this.tableData[this.currentIndex].surveyLabelList = this.surveyObj.surveyLabelList;
      this.tableData = [...this.tableData]
      // console.log(this.tableData)
      this.visible4 = false;
    },
    getGoodsName(list) {
      var strList = [];
      list.forEach((item) => {
        strList.push(item.goodsName);
      });
      return strList.join('、');
    },
    //选择限定产品后
    getLimitProducts(res) {
      let goodsInfo = [];
      if (res.goodsInfo.length) {
        res.goodsInfo.forEach(item => {
          goodsInfo.push({
            guid: item,
            goodsName: null,
            unitStyle: null,
            goodsSpec: null,
          })
        })
      }else{
        goodsInfo = [];
      }
  
      if (res.isAll == 'Y') {
        this.tableData.forEach(item => {
          if(this.limitTaskDicts.indexOf(item.taskContentType)>-1){
            item.goodsInfo = goodsInfo;
            item.multipleSelection = goodsInfo
          }
        })
      } else {
        this.tableData[this.currentIndex].goodsInfo = goodsInfo;
        this.tableData[this.currentIndex].multipleSelection = goodsInfo;
      }
    },
    getLevelList() {
      this.api
        .get(`/${serverConfig.msConfigureService}/dict/data/get-by-dictType?dictType=可限定产品的任务`)
        .then((resp) => {
          console.log(resp.data);
          if (resp.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let data = resp.data.data;

            if (!data || !data.length) return;
            let limitTaskDicts = [];
            data.forEach(item => {
              limitTaskDicts.push(item.value);
            })
            console.log(limitTaskDicts)
            this.limitTaskDicts = limitTaskDicts;
           
          }
        });
    },
    getDetail(detailList) {
      if (this.delFlag) {
        this.delFlag = false;
        return;
      }
      // console.log(detailList)
      var self = this;
      this.tableData = [];
      detailList.forEach((el, ky) => {
        var tableItem = {
          departmentData: [], //部门
          taskType: '', //任务大类
          taskTypeGuid: '',//任务大类Guid
          taskContentName: '', //任务名称
          taskContentList: [], //任务名称list
          taskContentGuid: '',
          menuUrl: '', // 系统功能路径
          menuName: '', //系统功能
          taskContentJson: '',
          isAllowTenantUse: '',
          taskPrice: '', //任务价格
          taskPriceUnit: '',
          taskPriceUnitGuid: '',
          taskAvg:'',
          taskTotal: '',
          taskTotalUnit: '',
          taskTotalUnitGuid: '',

          tenantTaskPrice: '', //药企报价
          tenantTaskPriceUnit: '',
          tenantTaskPriceUnitGuid: '',
          tenantTaskContentName:'',
          activeTemlate:'',
          settleRule: "1", //1单价 2比例

          contractTaskType: 0,// 0=正常 1=该任务未签署合同 2=该任务在当前企业合同中未签约，请尽快签署补充协议变更合同任务
          contractTaskPrice: '',//合同价格

          taskCode:'',//任务编码
          goodsCategoryJson:[],//产品分类
          marketingCategoryJson:[],//市场分类
          staffCategoryJson:[],//分类对象
          taskCategory:[],//任务分类
          taskMediumType:'',//任务中类
          isNormalTask:'',//是否常规任务

          isAskClock: '', //是否要求打卡 是/否

          isAskPhoto: '', //是否要求拍照 是/否
          minAskPhoto: '', //最少要求拍照数量

          isAskUpload: '', //是否要求上传资料 是/否
          minAskUpload: '', //最少上传资料数量

          isOpenMaxTask: 'Y', //是否开启超量上限拦截
          maxTaskValue: 0,  // 超量限制

          taskTag: '', //任务要求
          multipleSelection: [], //品种
          calcType: '系统计算',
          tenantWorkNote: '', //药企工作要求
          tenantTaskNote: '', //药企任务文案
          staffWorkNote: '', //运营工作要求
          staffTaskNote: '', //运营任务文案
          taskLabel: '',
          clientAreaRadio: '不限区域',
          clientAreaLabel: [],
          clientArea: [],
          clientObject: '',
          fileList: [],
          guid: el.guid,
          isTeamLeader: '',
          surveyObj: null,
          parentTemplateDetailName: '',
          parentTemplateDetailGuid: '',
          countRule:'',
          terminalTypeClassificationJson:[],
          //折扣比例
          discountRatio:'',
          floatDiscountRatio:'',
          staffMinPrice:'',
          staffMaxPrice:'',
          tenantMinPrice:'',
          tenantMaxPrice:'',
          staffBasePrice:'',
          ruleCoefficient:'',
          checkDiscountMsg: '',
          surveyLabelList: el.surveyLabelList,
        };
        tableItem.countRule = el.countRule;
        //根名
        tableItem.parentTemplateDetailName = el.parentTemplateDetailName;
        tableItem.parentTemplateDetailGuid = el.parentTemplateDetailGuid;

        //任务大类
        tableItem.taskType = el.taskType;
        tableItem.taskTypeGuid = el.taskTypeGuid;
        self.getTaskContentList(el.taskType, ky);
        self.getTaskReqList(el.taskContentGuid, ky);

        //任务名称
        tableItem.taskContentName = el.taskContentName;
        tableItem.taskContentGuid = el.taskContentGuid;
        tableItem.menuUrl = el.menuUrl;
        tableItem.menuName = el.menuName;
        tableItem.menuRemark = el.menuRemark;
        tableItem.taskContentJson = el.taskContentJson;
        tableItem.isTeamLeader = el.isTeamLeader;
        tableItem.isAllowTenantUse = el.isAllowTenantUse;
        tableItem.taskContentType = el.taskContentType;
        // N7 行级化：标注行 labelConfig 随行带入（三列交互与行级"更多"都读写它；漏带会导致配置恒空）
        tableItem.labelConfig = el.labelConfig;
        tableItem._sourceTaskDetailGuid = el._sourceTaskDetailGuid;
        tableItem.clientObject = el.clientObject;
        
        //任务编码
        tableItem.taskCode = el.taskCode;
        //产品分类
        tableItem.goodsCategoryJson = el.goodsCategoryJson;
        //市场分类
        tableItem.marketingCategoryJson = el.marketingCategoryJson;

        tableItem.staffCategoryJson = el.staffCategoryJson;
        tableItem.taskCategory = el.taskCategory;//任务分类
        //任务中类
        tableItem.taskMediumType = el.taskMediumType;
        //是否常规任务
        tableItem.isNormalTask = el.isNormalTask;
       
       

        //药企价格
        tableItem.tenantTaskPrice = el.tenantTaskPrice;
        // 行级化混合包的 SJBZ 行与 API 建包可能无价格单位（NULL），裸 replace 会炸整表搬运
        tableItem.tenantTaskPriceUnit = (el.tenantTaskPriceUnit || '').replace(' ', '');
        tableItem.tenantTaskPriceUnitGuid = el.tenantTaskPriceUnitGuid;
        tableItem.tenantTaskContentName = el.tenantTaskContentName;
        tableItem.activeTemlate = el.activeTemlate;

        //业务员报价
        tableItem.taskPrice = el.taskPrice;
        tableItem.taskPriceUnit = (el.taskPriceUnit || '').replace(' ', '');
        tableItem.taskPriceUnitGuid = el.taskPriceUnitGuid;

        tableItem.settleRule = el.settleRule; //1单价 2比例
        tableItem.settlePercent = el.settlePercent; //1单价 2比例
        //终端类型
        tableItem.terminalTypeClassificationJson = el.terminalTypeClassificationJson;
        //药企区间价
        tableItem.tenantMinPrice = el.tenantMinPrice;
        tableItem.tenantMaxPrice = el.tenantMaxPrice;
        tableItem.discountRatio = el.discountRatio
        tableItem.floatDiscountRatio = el.floatDiscountRatio
        
        //业务员区间价
        tableItem.staffMinPrice = el.staffMinPrice;
        tableItem.staffMaxPrice = el.staffMaxPrice;
        //业务员基础报价
        tableItem.staffBasePrice = el.staffBasePrice;
        //规则系数
        tableItem.ruleCoefficient = el.ruleCoefficient;
     

        //是否要求打卡
        tableItem.isAskClock = el.isAskClock;

        //是否要求拍照
        tableItem.isAskPhoto = el.isAskPhoto;

        //最少要求拍照数量
        tableItem.minAskPhoto = el.minAskPhoto;

        //是否要求上传资料
        tableItem.isAskUpload = el.isAskUpload;

        //最少上传资料数量
        tableItem.minAskUpload = el.minAskUpload;


        tableItem.isOpenMaxTask = el.isOpenMaxTask || 'Y';
        tableItem.maxTaskValue = el.maxTaskValue || 0;

        //任务量设置
        tableItem.taskAvg = el.taskAvg;
        tableItem.taskTotal = el.taskTotal;
        // SJBZ 固定量人均（以量定人）输入框语义=人均：宿主处于可编辑态（建包页 isPartDisabled=false
        // 恒可编辑；02 页 disabled=false 即 is_edit 编辑态，SJBZ 行经输入区行级豁免渲染人均输入框）时
        // 回显把 taskAvg 放进输入框绑定值 taskTotal（旧值=总量，直接沿用会把总量当人均提交）；只读态
        // （02 页非 is_edit）不换算，保留 taskTotal=总量供只读兜底显示，其提交侧取库值 taskAvg 回传
        if (el.taskContentType === 'SJBZ' && (el.taskTotalType || el.calcType) === '固定量人均'
          && (!this.isPartDisabled || !this.disabled)) {
          tableItem.taskTotal = el.taskAvg != null && el.taskAvg !== '' ? el.taskAvg : '';
        }
        tableItem.taskTotalUnit = el.taskTotalUnit;
        tableItem.taskTotalUnitGuid = el.taskTotalUnitGuid;
        //商品
        var multipleSelection = [];
        console.log(el.goodsInfo,'goodsInfo')
        var goodsInfo = el.goodsInfo ? typeof el.goodsInfo=='string'? JSON.parse(el.goodsInfo):el.goodsInfo : [];
        if (goodsInfo.length != 0) {
          goodsInfo.forEach((i) => {
            multipleSelection.push({
              guid: i.guid,
              goodsName: i.name,
              unitStyle: i.goodsUnit,
              goodsSpec: i.goodsSpec,
            });
          });
        }
        tableItem.multipleSelection = multipleSelection;
        //客户区域
        if (!Array.isArray(el.clientArea)) {
          var clientArea = el.clientArea ? JSON.parse(el.clientArea) : [];
          // console.log(clientArea)
          clientArea.forEach((item) => {
            if (item.name == '本区域' || item.name == '不限区域') {
              tableItem.clientAreaRadio = item.name;
            } else {
              tableItem.clientAreaRadio = '指定区域';
              tableItem.clientArea.push([item.provinceCode, item.guid]);
              if (item.name) {
                tableItem.clientAreaLabel.push(item.name);
              }

            }
          });
        } else {
          var clientArea = el.clientArea
          // console.log(clientArea)
          clientArea.forEach((item) => {
            if (item.name == '本区域' || item.name == '不限区域') {
              tableItem.clientAreaRadio = item.name;
            } else {
              tableItem.clientAreaRadio = '指定区域';
              tableItem.clientArea.push([item.provinceCode, item.guid]);
              if (item.name) {
                tableItem.clientAreaLabel.push(item.name);
              }
            }
          });
        }
        //药企任务文案 、药企工作要求 运营任务文案 运营工作文案
        // 行级化混合包/SJBZ 行可能无文案（NULL），先判空防炸整表搬运
        if (el.staffWorkNote && el.staffWorkNote.indexOf('[') > -1) {
          tableItem.staffWorkNote = JSON.parse(el.staffWorkNote);
          tableItem.staffWorkNote = tableItem.staffWorkNote.join('\n')
        } else {
          tableItem.staffWorkNote = el.staffWorkNote
        }

        tableItem.staffTaskNote = el.staffTaskNote;
        tableItem.tenantWorkNote = el.tenantWorkNote;
        tableItem.tenantTaskNote = el.tenantTaskNote;


        tableItem.surveyObj = el.surveyObj;

        //图标
        tableItem.fileList = el.taskIcon ? JSON.parse(el.taskIcon) : el.fileList;

        //任务要求
        tableItem.taskTag = !Array.isArray(el.taskTag) ? JSON.parse(el.taskTag) : el.taskTag;
        //标签
        tableItem.taskLabel = !Array.isArray(el.taskLabel) ? JSON.parse(el.taskLabel) : el.taskLabel;
        //是否在合同里
        tableItem.contractTaskType = el.contractTaskType;
        //合同价格
        tableItem.contractTaskPrice = el.contractTaskPrice;
        //任务编码
        tableItem.taskCode = el.taskCode;
        //产品分类
        tableItem.goodsCategoryJson = el.goodsCategoryJson;
        //市场分类
        tableItem.marketingCategoryJson = el.marketingCategoryJson;

        tableItem.staffCategoryJson = el.staffCategoryJson;
        tableItem.taskCategory = el.taskCategory;//任务分类
        //任务中类
        tableItem.taskMediumType = el.taskMediumType;
        //是否常规任务
        tableItem.isNormalTask = el.isNormalTask;

        //终端类型
        tableItem.terminalTypeClassificationJson = el.terminalTypeClassificationJson;
        //药企区间价
        tableItem.tenantMinPrice = el.tenantMinPrice;
        tableItem.tenantMaxPrice = el.tenantMaxPrice;
        tableItem.discountRatio = el.discountRatio
        tableItem.floatDiscountRatio = el.floatDiscountRatio
        
        //业务员基础报价
        tableItem.staffBasePrice = el.staffBasePrice;
        //规则系数
        tableItem.ruleCoefficient = el.ruleCoefficient;
        tableItem.checkDiscountMsg = el.checkDiscountMsg;


        // SJBZ 行计算方式不锁定（2026-09-29 拍板"不写死"）：随库值/模板值展示、可切换；
        // 输入框语义随计算方式分流（固定量人均=人均、系统计算=总量由标注数据带出），提交侧同款分流
        if(el.settleRule == 2){
          //任务结算方式为按比例结算 计算方式为不限量
          tableItem.calcType = '不限量';
          tableItem.isOpenMaxTask = 'N';
        }else{
           //计算方式
          tableItem.calcType = el.taskTotalType || el.calcType;
        }

        // tableItem.taskLabel = el.taskLabel?JSON.parse(el.taskLabel):[];

        self.tableData.push(tableItem);
       

      });
    },
    //选择部门
    handleChooseDepart() {
      this.visible3 = true;
    },

    getDeliverName(res) {
      var list = res;
      var strList = [];
      if (list.length == 0) return;
      list.forEach((item) => {
        strList.push(item.organisationName);
      });
      return strList.join('、');
    },
    getTenantList() {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        enterpriseCates: this.$getValueListByKey('上游客户分类'),
      };
      self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tenantList = res.data.data.records;
          self.handleSelectFactory();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getSendTenantList() {
      let self = this;
      let query = {
        isService: true,
        tenantGuid: localStorage.guid,
      };
      self.api
        .get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.sendTenantList = res.data.data;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    getTaskTypeList() {
      let req = {
        pageIndex: 1,
        pageSize: -1,
        bizType: '任务大类',
        tenantGuid: localStorage.guid,
      };
      let self = this;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-param/data/get-list`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.taskTypeList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getTaskContentList(taskType, currentIndex) {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        taskType: taskType,
      };
      self.api.postJson(`/${serverConfig.msSalesPerformService}/task-set/content/get-list`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData[currentIndex].taskContentList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getTaskReqList(paramValue1, currentIndex) {
      let self = this;
      let req = {
        pageIndex: 1,
        pageSize: -1,
        bizType: '工作要求',
        tenantGuid: localStorage.guid,
        paramValue1: paramValue1,
      };
      self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-param/data/get-list`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData[currentIndex].taskReqList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getTaskTotalUnitList() {
      let self = this;
      let req = {
        pageIndex: 1,
        pageSize: -1,
        bizType: '任务单位',
        paramName: '任务总量单位', //单位类型
        // tenantGuid: localStorage.guid,
      };
      self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-param/data/get-list`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.taskTotalUnitList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getTaskPriceUnitList() {
      let self = this;
      let req = {
        pageIndex: 1,
        pageSize: -1,
        bizType: '任务单位',
        paramName: '任务价格单位', //单位类型
        // tenantGuid: localStorage.guid,
      };
      self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-param/data/get-list`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.taskPriceUnitList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    handleSelectTaskType(taskType, currentIndex) {
      this.tableData[currentIndex].taskContentName = '';
      this.getTaskContentList(taskType, currentIndex);
    },
    handleSelectContentName(row, currentIndex) {
      var taskContentList = row.taskContentList;
      var taskContentName = row.taskContentName;
      taskContentList.forEach((item) => {
        if (item.taskContentName == taskContentName) {
          this.tableData[currentIndex].menuName = item.menuName;
          this.tableData[currentIndex].menuUrl = item.menuUrl;
          this.tableData[currentIndex].taskContentJson = item.taskContentJson;
          this.tableData[currentIndex].isAllowTenantUse = item.isAllowTenantUse;
        }
      });
    },
    handleSelectFactory() {
      var tenantList = this.tenantList;
      var tableData = this.tableData;
      tenantList.forEach((item) => {
        if (item.tenantName == this.tenantName) {
          this.getData();
          this.getOrganisation(item.guid);
          tableData.forEach((item) => {
            // item.departmentData = [];
            // item.multipleSelection = [];
          });
          this.tableData = tableData;
        }
      });
    },
    delVersion(index) {
      this.tableData.splice(index, 1);
      this.$emit('delItem', index);
      this.delFlag = true;
    },
    editVersion(index) {
      this.textTitle = this.tableData[index].taskContentName
        ? `【${this.tableData[index].taskContentName}】编辑`
        : '任务名称编辑';
      this.dialogVisible = true;
      this.currentIndex = index;
      // N7 行级化：标注行三域以 labelConfig 为准预填（API 建包行 note 字段可能为空，避免弹框空白）
      if (this.isSjbzRow(this.tableData[index])) {
        const conf = this.sjbzConf(this.tableData[index]);
        this.tableData[index].staffTaskNote = this.tableData[index].staffTaskNote || conf.workDesc || '';
        this.tableData[index].tenantTaskNote = this.tableData[index].tenantTaskNote || conf.workDetail || '';
        this.tableData[index].staffWorkNote = this.tableData[index].staffWorkNote || conf.workRequire || '';
      }
    },
    //获取组织
    getOrganisation(guid) {
      let self = this;
      self.api
        .get(
          `/${serverConfig.msPersonnelService}/organisation/data/get-organisation-detail?bizState=Y&tenantGuid=` + guid,
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.areaData = res.data.data;
          } else {
            self.$message.error(res.data.msg);
            self.areaData = [];
            self.tableData = [];
          }
        });
    },
    unique(arr) {
      //Set数据结构，它类似于数组，其成员的值都是唯一的
      return Array.from(new Set(arr)); // 利用Array.from将Set结构转换成数组
    },
    //部门弹框选择
    handleNodeClick1(data) {
      this.departmentList = this.$refs.tree.getCheckedNodes(false);
      this.$forceUpdate();
    },
    //确定选择部门
    departmentSure() {
      if (this.departmentList.length == 0) {
        this.$message.error('请勾选部门！');
        return;
      }
      this.visible3 = false;
    },
    handleSelectionChange1(val) {
      let self = this;
      self.delList = val;
    },
    //删除部门
    delDepartment() {
      let self = this;
      if (self.delList == null || self.delList.length == 0) {
        self.$message.error('请勾选部门！');
        return;
      }
      self.delList.forEach(function (j) {
        self.departmentList.forEach(function (i, index) {
          if (i.guid == j.guid) {
            self.departmentList.splice(index, 1);
          }
        });
      });
      self.delList.forEach(function (m) {
        self.area.forEach(function (n, idn) {
          if (JSON.parse(n).guid == m.guid) {
            self.area.splice(idn, 1);
          }
        });
      });
    },
    //删除单个部门
    delDepartmentSingle(index) {
      this.departmentData.splice(index, 1);
      this.departmentList = this.departmentData;
      this.area.splice(index, 1);
      // this.departmentList.splice(index,1)
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.organisationName.indexOf(value) !== -1;
    },
    //获取产品数据
    getData() {
      let self = this;
      let tenantGuid = this.sendTenantGuid
      self.pageII.tenantGuid = tenantGuid;

      self.api.postJson(`/${serverConfig.msProductService}/goods/data/get`, self.pageII).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.productInformationList = res.data.data.records;
          self.pageII.totalPage = res.data.data.totalPages;
          self.pageII.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getSurvey() {
      let self = this;
      let tenantGuid = this.sendTenantGuid
      self.surveyPage.tenantGuid = tenantGuid;
      self.surveyPage.isSelectTemplate = 'Y';
      self.api.postJson(`/${serverConfig.msSalesPerformService}/survey/tenant/list`, self.surveyPage).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.surveyList = res.data.data.records;
          self.surveyList=self.surveyList.filter(item => item.isDraft!== 'Y')
          self.surveyPage.totalPage = res.data.data.totalPages;
          self.surveyPage.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    handleSizeChangeSurvey(val) {
      let self = this;
      self.surveyPage.pageSize = val;
      this.getData();
    },
    handleCurrentChangeSurvey(val) {
      let self = this;
      self.surveyPage.pageIndex = val;
      this.getSurvey();
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件`);
    },
    handleRemove(file) {
      let self = this;
      self.tableData[this.currentIndex].fileList.forEach(function (j, ind) {
        if (j.url == file.url) {
          self.tableData[self.currentIndex].fileList.splice(ind, 1);
        }
      });
    },
    uploadImage(file) {
      let self = this;
      // console.log(file.file);
      let formData = new FormData();
      formData.append('image', file.file);
      self.api
        .postImage(self.urlImg, formData)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let item = {
              name: '任务图',
              url: res.data.data,
            };
            self.tableData[self.currentIndex].fileList.push(item);
            self.$message.success('上传成功');
          } else {
            elf.$message.error('上传失败,请重新上传!');
          }
        })
        .catch(() => {
          self.$message('上传失败,请重新上传');
        });
    },
    handleSizeChange1(val) {
      let self = this;
      self.pageII.pageSize = val;
      this.getData();
    },
    handleCurrentChange1(val) {
      let self = this;
      self.pageII.pageIndex = val;
      this.getData();
    },
    handleSelectionChange(val) {
      let self = this;
      self.tableData[this.currentIndex].multipleSelection = val;
    },
    btn(row, col, event) {
      row.flag = !row.flag;
      this.$refs.dataTable.toggleRowSelection(row, row.flag);
    },
    //获取图标数据
    getIconList() {
      let self = this;
      let req = {
        pageIndex: 1,
        pageSize: -1,
        totalPage: 0,
        totalRows: 0,
        bizType: '图标管理',
        paramName: '',
        // tenantGuid: localStorage.guid,
        // tenantName: JSON.parse(localStorage.userInfo).tenantName,
      };
      self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-param/data/get-list`, req).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.iconList = res.data.data.records;
          self.activeIcon = 0;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    handleClickMenu(index) {
      this.activeIcon = index;
    },
    chooseIcon(url) {
      this.chooseURL = url;
    },
    delPic() {
      return;
      if (this.disabled) return;
      this.tableData[this.currentIndex].fileList = [];
      this.$forceUpdate();
    },
    addPic() {
      return;
      if (this.disabled) return;
      if (this.tableData[this.currentIndex].fileList.length != 0) {
        this.$message.error('任务图标只能选择一个');
        return;
      }
      this.iconVisible = true;
    },
    moreSureIcon() {
      if (!this.chooseURL) {
        this.$message.error('请选择任务图标');
        return;
      }
      this.tableData[this.currentIndex].fileList = [
        {
          name: '任务图',
          url: this.chooseURL,
        },
      ];

      this.iconVisible = false;
      this.$forceUpdate();
    },
    getLabelOrCreate() {
      let that = this;
      that.api.get(
        `/${serverConfig.msConfigureService}/dict/data/get-by-dictType?dictType=任务标签`,
      ).then((resp) => {
        const { data } = resp
        // console.log(data)
        // 字典分类【任务标签】不存在，则需要新增
        if (data.msg != 'success') {
          that.api.postJson(
            `/${serverConfig.msConfigureService}/dict/save-class`,
            {
              "guid": '',
              "dictTypeName": "任务标签",
              "orderNum": 0
            }
          ).then((res) => {
          });
        } else {
          that.api.get(`/${serverConfig.msConfigureService}/dict/data/get-by-dictType?dictType=任务标签`).then((res) => {
            let list = res.data.data || [];
            this.taskLabelListList = [];
            list.forEach(item => {
              if (item.text) {
                this.taskLabelListList.push(item.text)
              }
            })
            this.$forceUpdate();
          });

        }
      });
    },
    addLable() {
      if (!this.taskLabelVal) {
        this.$message.error('请填写标签')
        return;
      }
      if (this.tableData[this.currentIndex].taskLabel.length == 3) {
        this.$message.error('最多添加三个！')
        return;
      }
      this.api.postJson(
        `/${serverConfig.msConfigureService}/dict/save-dict`,
        {
          "dicValue": this.taskLabelVal,
          "dicName": this.taskLabelVal,
          "parentName": "任务标签",
          "orderNum": 0
        }
      ).then((resp) => {
        if (resp.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.tableData[this.currentIndex].taskLabel.push(this.taskLabelVal)
          this.taskLabelVal = '';
          this.getLabelOrCreate();
        } else {
          this.taskLabelVal = '';
          this.$message.error(resp.data.msg);
        }
      });
    },

  },
};
</script> 
<style scoped>
.sjbz-label-capacity-tip {
  color: #909399;
  line-height: 20px;
}
/* FOUR-3001：选择标签多行下拉（每行=下拉+删除，底部添加） */
.sjbz-label-rows {
  width: 100%;
  text-align: left;
}
.sjbz-label-row {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}
.sjbz-label-del {
  margin-left: 6px;
  flex-shrink: 0;
}
/* N7 行级化：标注人员要求弹框副标题（与协配页标注表单区块标题风格一致） */
.sjbz-req-subtitle {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  text-align: left;
  padding: 4px 0 12px;
}
.sjbz-req-tip {
  font-size: 12px;
  font-weight: 400;
  color: #909399;
}
/* N7 行级化：详情态纯文本视图已抽为共用组件 LabelReqView（样式随组件走） */
.ratio-msg{
  color:red;
  padding-top:4px;
  font-size:12px;

}
#template-config /deep/ .el-dialog {
  height: 80vh;
  overflow: auto;
}

/* .el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
} */

.el-range-editor.el-input__inner {
  padding: 0px;
}

/deep/ .el-checkbox__label {
  display: none;
}

.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}

.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}

.content {
  background: #fff;
  font-size: 18px;
}

.title {
  text-align: left;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.title span {
  width: 6px;
  height: 14px;
  background: #4fa1a4;
  display: inline-block;
  margin-right: 10px;
}

.base-content {
  display: flex;
  font-size: 15px;
  padding: 20px 0;
}

.base-content .base-info {
  display: flex;
  align-items: center;
  padding: 0 40px;
}

.base-content .base-info .base-title {
  word-break: keep-all;
}

.button-area {
  display: flex;
  justify-content: space-between;
  padding-right: 15px;
  margin-top: 0;
}

/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}

/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}

/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}

.icon-dialog {
  display: flex;
  overflow: hidden;
}

.icon-dialog .icon-left {
  width: 130px;
  text-align: left;
  border-right: 1px solid #cccc;
}

.icon-left .item {
  height: 40px;
  line-height: 40px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
  padding: 0 20px;
}

.icon-dialog .icon-right {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  height: auto;
  padding-left: 10px;
}

.icon-right .pic {
  width: 100px;
  height: 130px;
  margin-right: 10px;
  margin-bottom: 10px;
}

.icon-right .pic .img {
  width: 100px;
  height: 100px;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.06);
}

.icon-right .pic .img:hover {
  border: 1px solid #4fa1a4;
  border-radius: 4px;
}

.img-wrap {
  position: relative;
}

.img-wrap .border-img {
  position: absolute;
  width: 100px;
  height: 100px;
  left: 0;
  top: 0;
}

.img-wrap .name {
  width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.file-img {
  width: 100%;
  height: 100%;
}

.icon-add {
  float: left;
  margin-left: 10px;
  width: 150px;
  height: 150px;
  border: 1px dotted #ccc;
  text-align: center;
  line-height: 150px;
}

.img-close {
  position: relative;
  float: left;
  width: 150px;
  height: 150px;
  margin-left: 20px;
}

.close {
  position: absolute;
  right: 0;
  top: 0;
  width: 20px;
  height: 20px;
}

/deep/ .table_header {
  background-color: #F0F0F0 !important;
  padding: 10px 0;
  color: #323233;
}

/* /deep/ .el-table td {
  padding: 5px 0px;
} */
/deep/ .el-cascader .el-input .el-input__inner:focus,
.el-cascader .el-input.is-focus .el-input__inner {
  height: 33px;
}

/deep/ .el-cascader__tags {
  display: inline-flex;
  flex-wrap: nowrap;
  overflow: hidden;
}

.tabel-wrap {
  padding: 0px 20px 10px 20px;
}</style>
<style >
.active-ratio{
  border:1px solid red;
  border-radius:4px
}
.active-ratio .el-input__inner{
  border:0 none;
}
.icon-dialog-wrap .el-dialog__body {
  padding: 0;
  padding-top: 10px;
}

#template-config .el-form-item__content {
  margin-left: 15px !important;
}

#template-config .el-form-item {
  align-items: flex-start;
}

#template-config .calc-type .el-form-item__label {
  line-height: 15px;
}</style>

<style lang="less">
.cascader-popper {
  .el-cascader-menu {
    .el-cascader-menu__wrap {
      .el-cascader-menu__list {
        .is-disabled {
          display: none !important;
        }
      }
    }
  }
}
</style>
